import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
export class ChestItem {
  get descriptor() {
    return ChestItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasItemAmountMin = false;
    this._itemAmountMin = null;
    this._hasItemAmountMax = false;
    this._itemAmountMax = null;
    this._hasChanceWeight = false;
    this._chanceWeight = null;
    this._chanceWeightOverwriteInXTenDraws = [];
    this._hasUseXTenDrawWhenGetPromoted = false;
    this._useXTenDrawWhenGetPromoted = null;
    this._hasIsPromotedItem = false;
    this._isPromotedItem = null;
    this._hasAdditiveChanceWeightPerDraw = false;
    this._additiveChanceWeightPerDraw = null;
    this._hasClearCumulativeDrawCount = false;
    this._clearCumulativeDrawCount = null;
    this._hasDisplayText = false;
    this._displayText = null;
    this._hasDisplayDropRate = false;
    this._displayDropRate = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasItemAmountMin) return false;
    if (this._hasItemAmountMax) return false;
    if (this._hasChanceWeight) return false;
    if (this._chanceWeightOverwriteInXTenDraws.length > 0) return false;
    if (this._hasUseXTenDrawWhenGetPromoted) return false;
    if (this._hasIsPromotedItem) return false;
    if (this._hasAdditiveChanceWeightPerDraw) return false;
    if (this._hasClearCumulativeDrawCount) return false;
    if (this._hasDisplayText) return false;
    if (this._hasDisplayDropRate) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ChestItem) {
      return value;
    }
    return ChestItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new ChestItem();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.itemAmountMin != null) {
      result._hasItemAmountMin = true;
      result._itemAmountMin = JsonToInt32.fromJson(json.itemAmountMin);
    }
    if (json.itemAmountMax != null) {
      result._hasItemAmountMax = true;
      result._itemAmountMax = JsonToInt32.fromJson(json.itemAmountMax);
    }
    if (json.chanceWeight != null) {
      result._hasChanceWeight = true;
      result._chanceWeight = JsonToDouble.fromJson(json.chanceWeight);
    }
    result._chanceWeightOverwriteInXTenDraws = JsonToList(json.chanceWeightOverwriteInXTenDraws, JsonToDouble);
    if (json.useXTenDrawWhenGetPromoted != null) {
      result._hasUseXTenDrawWhenGetPromoted = true;
      result._useXTenDrawWhenGetPromoted = JsonToInt32.fromJson(json.useXTenDrawWhenGetPromoted);
    }
    if (json.isPromotedItem != null) {
      result._hasIsPromotedItem = true;
      result._isPromotedItem = JsonToBoolean.fromJson(json.isPromotedItem);
    }
    if (json.additiveChanceWeightPerDraw != null) {
      result._hasAdditiveChanceWeightPerDraw = true;
      result._additiveChanceWeightPerDraw = JsonToDouble.fromJson(json.additiveChanceWeightPerDraw);
    }
    if (json.clearCumulativeDrawCount != null) {
      result._hasClearCumulativeDrawCount = true;
      result._clearCumulativeDrawCount = JsonToBoolean.fromJson(json.clearCumulativeDrawCount);
    }
    if (json.displayText != null) {
      result._hasDisplayText = true;
      result._displayText = JsonToString.fromJson(json.displayText);
    }
    if (json.displayDropRate != null) {
      result._hasDisplayDropRate = true;
      result._displayDropRate = JsonToDouble.fromJson(json.displayDropRate);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasItemAmountMin) {
      result.itemAmountMin = JsonToInt32.toJson(this._itemAmountMin);
    }
    if (this._hasItemAmountMax) {
      result.itemAmountMax = JsonToInt32.toJson(this._itemAmountMax);
    }
    if (this._hasChanceWeight) {
      result.chanceWeight = JsonToDouble.toJson(this._chanceWeight);
    }
    if (this._chanceWeightOverwriteInXTenDraws.length > 0) {
      result.chanceWeightOverwriteInXTenDraws = ArrayToJson(this._chanceWeightOverwriteInXTenDraws, JsonToDouble);
    }
    if (this._hasUseXTenDrawWhenGetPromoted) {
      result.useXTenDrawWhenGetPromoted = JsonToInt32.toJson(this._useXTenDrawWhenGetPromoted);
    }
    if (this._hasIsPromotedItem) {
      result.isPromotedItem = JsonToBoolean.toJson(this._isPromotedItem);
    }
    if (this._hasAdditiveChanceWeightPerDraw) {
      result.additiveChanceWeightPerDraw = JsonToDouble.toJson(this._additiveChanceWeightPerDraw);
    }
    if (this._hasClearCumulativeDrawCount) {
      result.clearCumulativeDrawCount = JsonToBoolean.toJson(this._clearCumulativeDrawCount);
    }
    if (this._hasDisplayText) {
      result.displayText = JsonToString.toJson(this._displayText);
    }
    if (this._hasDisplayDropRate) {
      result.displayDropRate = JsonToDouble.toJson(this._displayDropRate);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get itemAmountMin() {
    return this._hasItemAmountMin ? this._itemAmountMin : JsonToInt32.default;
  }
  get hasItemAmountMin() {
    return this._hasItemAmountMin;
  }
  setItemAmountMin(path, value) {
    return {type: 'SET', path: path.concat(['itemAmountMin']), value};
  }
  deleteItemAmountMin(path) {
    return {type: 'DELETE', path: path.concat(['itemAmountMin'])};
  }
  /**
   * @returns {number}
   */
  get itemAmountMax() {
    return this._hasItemAmountMax ? this._itemAmountMax : JsonToInt32.default;
  }
  get hasItemAmountMax() {
    return this._hasItemAmountMax;
  }
  setItemAmountMax(path, value) {
    return {type: 'SET', path: path.concat(['itemAmountMax']), value};
  }
  deleteItemAmountMax(path) {
    return {type: 'DELETE', path: path.concat(['itemAmountMax'])};
  }
  /**
   * @returns {number}
   */
  get chanceWeight() {
    return this._hasChanceWeight ? this._chanceWeight : JsonToDouble.default;
  }
  get hasChanceWeight() {
    return this._hasChanceWeight;
  }
  setChanceWeight(path, value) {
    return {type: 'SET', path: path.concat(['chanceWeight']), value};
  }
  deleteChanceWeight(path) {
    return {type: 'DELETE', path: path.concat(['chanceWeight'])};
  }
  /**
   * @returns {number[]}
   */
  get chanceWeightOverwriteInXTenDraws() {
    return this._chanceWeightOverwriteInXTenDraws;
  }
  addChanceWeightOverwriteInXTenDraws(path, value) {
    return {type: 'ADD', path: path.concat(['chanceWeightOverwriteInXTenDraws']), value};
  }
  setChanceWeightOverwriteInXTenDraws(path, value) {
    return {type: 'SET', path: path.concat(['chanceWeightOverwriteInXTenDraws']), value: ArrayToJson(value, JsonToDouble)};
  }
  setChanceWeightOverwriteInXTenDrawsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['chanceWeightOverwriteInXTenDraws', key]), value};
  }
  deleteChanceWeightOverwriteInXTenDraws(path) {
    return {type: 'DELETE', path: path.concat(['chanceWeightOverwriteInXTenDraws'])};
  }
  deleteChanceWeightOverwriteInXTenDrawsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['chanceWeightOverwriteInXTenDraws', key])};
  }
  /**
   * @returns {number}
   */
  get useXTenDrawWhenGetPromoted() {
    return this._hasUseXTenDrawWhenGetPromoted ? this._useXTenDrawWhenGetPromoted : JsonToInt32.default;
  }
  get hasUseXTenDrawWhenGetPromoted() {
    return this._hasUseXTenDrawWhenGetPromoted;
  }
  setUseXTenDrawWhenGetPromoted(path, value) {
    return {type: 'SET', path: path.concat(['useXTenDrawWhenGetPromoted']), value};
  }
  deleteUseXTenDrawWhenGetPromoted(path) {
    return {type: 'DELETE', path: path.concat(['useXTenDrawWhenGetPromoted'])};
  }
  /**
   * @returns {boolean}
   */
  get isPromotedItem() {
    return this._hasIsPromotedItem ? this._isPromotedItem : JsonToBoolean.default;
  }
  get hasIsPromotedItem() {
    return this._hasIsPromotedItem;
  }
  setIsPromotedItem(path, value) {
    return {type: 'SET', path: path.concat(['isPromotedItem']), value};
  }
  deleteIsPromotedItem(path) {
    return {type: 'DELETE', path: path.concat(['isPromotedItem'])};
  }
  /**
   * @returns {number}
   */
  get additiveChanceWeightPerDraw() {
    return this._hasAdditiveChanceWeightPerDraw ? this._additiveChanceWeightPerDraw : JsonToDouble.default;
  }
  get hasAdditiveChanceWeightPerDraw() {
    return this._hasAdditiveChanceWeightPerDraw;
  }
  setAdditiveChanceWeightPerDraw(path, value) {
    return {type: 'SET', path: path.concat(['additiveChanceWeightPerDraw']), value};
  }
  deleteAdditiveChanceWeightPerDraw(path) {
    return {type: 'DELETE', path: path.concat(['additiveChanceWeightPerDraw'])};
  }
  /**
   * @returns {boolean}
   */
  get clearCumulativeDrawCount() {
    return this._hasClearCumulativeDrawCount ? this._clearCumulativeDrawCount : JsonToBoolean.default;
  }
  get hasClearCumulativeDrawCount() {
    return this._hasClearCumulativeDrawCount;
  }
  setClearCumulativeDrawCount(path, value) {
    return {type: 'SET', path: path.concat(['clearCumulativeDrawCount']), value};
  }
  deleteClearCumulativeDrawCount(path) {
    return {type: 'DELETE', path: path.concat(['clearCumulativeDrawCount'])};
  }
  /**
   * @returns {string}
   */
  get displayText() {
    return this._hasDisplayText ? this._displayText : JsonToString.default;
  }
  get hasDisplayText() {
    return this._hasDisplayText;
  }
  setDisplayText(path, value) {
    return {type: 'SET', path: path.concat(['displayText']), value};
  }
  deleteDisplayText(path) {
    return {type: 'DELETE', path: path.concat(['displayText'])};
  }
  /**
   * @returns {number}
   */
  get displayDropRate() {
    return this._hasDisplayDropRate ? this._displayDropRate : JsonToDouble.default;
  }
  get hasDisplayDropRate() {
    return this._hasDisplayDropRate;
  }
  setDisplayDropRate(path, value) {
    return {type: 'SET', path: path.concat(['displayDropRate']), value};
  }
  deleteDisplayDropRate(path) {
    return {type: 'DELETE', path: path.concat(['displayDropRate'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "itemAmountMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasItemAmountMin = true;
              copy._itemAmountMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemAmountMin) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasItemAmountMin = false;
              copy._itemAmountMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "itemAmountMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasItemAmountMax = true;
              copy._itemAmountMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemAmountMax) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasItemAmountMax = false;
              copy._itemAmountMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chanceWeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasChanceWeight = true;
              copy._chanceWeight = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChanceWeight) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasChanceWeight = false;
              copy._chanceWeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chanceWeightOverwriteInXTenDraws": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._chanceWeightOverwriteInXTenDraws = [];        for (let i of value) {
                copy._chanceWeightOverwriteInXTenDraws.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ChestItem(this);
              copy._chanceWeightOverwriteInXTenDraws = copy._chanceWeightOverwriteInXTenDraws.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._chanceWeightOverwriteInXTenDraws.length === 0) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._chanceWeightOverwriteInXTenDraws = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._chanceWeightOverwriteInXTenDraws.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._chanceWeightOverwriteInXTenDraws = copy._chanceWeightOverwriteInXTenDraws.slice();
              copy._chanceWeightOverwriteInXTenDraws[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ChestItem(this);
              copy._chanceWeightOverwriteInXTenDraws = copy._chanceWeightOverwriteInXTenDraws.slice(0, path[1]).concat(copy._chanceWeightOverwriteInXTenDraws.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._chanceWeightOverwriteInXTenDraws.length) {
            return this;
          }
          const oldValue = this._chanceWeightOverwriteInXTenDraws[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ChestItem(this);
          copy._chanceWeightOverwriteInXTenDraws = copy._chanceWeightOverwriteInXTenDraws.slice();
          copy._chanceWeightOverwriteInXTenDraws[key] = newValue;
          return copy;
        }
      }
      case "useXTenDrawWhenGetPromoted": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasUseXTenDrawWhenGetPromoted = true;
              copy._useXTenDrawWhenGetPromoted = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseXTenDrawWhenGetPromoted) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasUseXTenDrawWhenGetPromoted = false;
              copy._useXTenDrawWhenGetPromoted = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isPromotedItem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasIsPromotedItem = true;
              copy._isPromotedItem = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsPromotedItem) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasIsPromotedItem = false;
              copy._isPromotedItem = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "additiveChanceWeightPerDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasAdditiveChanceWeightPerDraw = true;
              copy._additiveChanceWeightPerDraw = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAdditiveChanceWeightPerDraw) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasAdditiveChanceWeightPerDraw = false;
              copy._additiveChanceWeightPerDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "clearCumulativeDrawCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasClearCumulativeDrawCount = true;
              copy._clearCumulativeDrawCount = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClearCumulativeDrawCount) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasClearCumulativeDrawCount = false;
              copy._clearCumulativeDrawCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayText": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasDisplayText = true;
              copy._displayText = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayText) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasDisplayText = false;
              copy._displayText = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayDropRate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestItem(this);
              copy._hasDisplayDropRate = true;
              copy._displayDropRate = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayDropRate) {
                return this;
              }
              const copy = new ChestItem(this);
              copy._hasDisplayDropRate = false;
              copy._displayDropRate = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ChestItem} other
   * @returns {ChestItem}
   */
  merge(other) {
    const copy = new ChestItem(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasItemAmountMin) {
      copy._hasItemAmountMin = true;
      copy._itemAmountMin = other._itemAmountMin;
    }
    if (other._hasItemAmountMax) {
      copy._hasItemAmountMax = true;
      copy._itemAmountMax = other._itemAmountMax;
    }
    if (other._hasChanceWeight) {
      copy._hasChanceWeight = true;
      copy._chanceWeight = other._chanceWeight;
    }
    copy._chanceWeightOverwriteInXTenDraws = this._chanceWeightOverwriteInXTenDraws.concat(other._chanceWeightOverwriteInXTenDraws);
    if (other._hasUseXTenDrawWhenGetPromoted) {
      copy._hasUseXTenDrawWhenGetPromoted = true;
      copy._useXTenDrawWhenGetPromoted = other._useXTenDrawWhenGetPromoted;
    }
    if (other._hasIsPromotedItem) {
      copy._hasIsPromotedItem = true;
      copy._isPromotedItem = other._isPromotedItem;
    }
    if (other._hasAdditiveChanceWeightPerDraw) {
      copy._hasAdditiveChanceWeightPerDraw = true;
      copy._additiveChanceWeightPerDraw = other._additiveChanceWeightPerDraw;
    }
    if (other._hasClearCumulativeDrawCount) {
      copy._hasClearCumulativeDrawCount = true;
      copy._clearCumulativeDrawCount = other._clearCumulativeDrawCount;
    }
    if (other._hasDisplayText) {
      copy._hasDisplayText = true;
      copy._displayText = other._displayText;
    }
    if (other._hasDisplayDropRate) {
      copy._hasDisplayDropRate = true;
      copy._displayDropRate = other._displayDropRate;
    }
    return copy;
  }
}
ChestItem.default = new ChestItem();
class ChestItem_Builder {
  constructor(value) {
    this._value = new ChestItem(value);
  }
  build() {
    return new ChestItem(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setItemAmountMin(value) {
    this._value._hasItemAmountMin = true;
    this._value._itemAmountMin = value;
    return this;
  }
  deleteItemAmountMin() {
    this._value._hasItemAmountMin = false;
    this._value._itemAmountMin = null;
    return this;
  }
  setItemAmountMax(value) {
    this._value._hasItemAmountMax = true;
    this._value._itemAmountMax = value;
    return this;
  }
  deleteItemAmountMax() {
    this._value._hasItemAmountMax = false;
    this._value._itemAmountMax = null;
    return this;
  }
  setChanceWeight(value) {
    this._value._hasChanceWeight = true;
    this._value._chanceWeight = value;
    return this;
  }
  deleteChanceWeight() {
    this._value._hasChanceWeight = false;
    this._value._chanceWeight = null;
    return this;
  }
  addAllChanceWeightOverwriteInXTenDraws(values) {
    this._value._chanceWeightOverwriteInXTenDraws = this._value._chanceWeightOverwriteInXTenDraws.concat(values);
    return this;
  }
  addChanceWeightOverwriteInXTenDraws(value) {
    this._value._chanceWeightOverwriteInXTenDraws = this._value._chanceWeightOverwriteInXTenDraws.concat([value]);
    return this;
  }
  setChanceWeightOverwriteInXTenDraws(index, value) {
    this._value._chanceWeightOverwriteInXTenDraws = this._value._chanceWeightOverwriteInXTenDraws.concat();
    this._value._chanceWeightOverwriteInXTenDraws[index] = value;
    return this;
  }
  clearChanceWeightOverwriteInXTenDraws() {
    this._value._chanceWeightOverwriteInXTenDraws = [];
    return this;
  }
  setUseXTenDrawWhenGetPromoted(value) {
    this._value._hasUseXTenDrawWhenGetPromoted = true;
    this._value._useXTenDrawWhenGetPromoted = value;
    return this;
  }
  deleteUseXTenDrawWhenGetPromoted() {
    this._value._hasUseXTenDrawWhenGetPromoted = false;
    this._value._useXTenDrawWhenGetPromoted = null;
    return this;
  }
  setIsPromotedItem(value) {
    this._value._hasIsPromotedItem = true;
    this._value._isPromotedItem = value;
    return this;
  }
  deleteIsPromotedItem() {
    this._value._hasIsPromotedItem = false;
    this._value._isPromotedItem = null;
    return this;
  }
  setAdditiveChanceWeightPerDraw(value) {
    this._value._hasAdditiveChanceWeightPerDraw = true;
    this._value._additiveChanceWeightPerDraw = value;
    return this;
  }
  deleteAdditiveChanceWeightPerDraw() {
    this._value._hasAdditiveChanceWeightPerDraw = false;
    this._value._additiveChanceWeightPerDraw = null;
    return this;
  }
  setClearCumulativeDrawCount(value) {
    this._value._hasClearCumulativeDrawCount = true;
    this._value._clearCumulativeDrawCount = value;
    return this;
  }
  deleteClearCumulativeDrawCount() {
    this._value._hasClearCumulativeDrawCount = false;
    this._value._clearCumulativeDrawCount = null;
    return this;
  }
  setDisplayText(value) {
    this._value._hasDisplayText = true;
    this._value._displayText = value;
    return this;
  }
  deleteDisplayText() {
    this._value._hasDisplayText = false;
    this._value._displayText = null;
    return this;
  }
  setDisplayDropRate(value) {
    this._value._hasDisplayDropRate = true;
    this._value._displayDropRate = value;
    return this;
  }
  deleteDisplayDropRate() {
    this._value._hasDisplayDropRate = false;
    this._value._displayDropRate = null;
    return this;
  }
}
ChestItem.Builder = ChestItem_Builder;
class ChestItem_WithParent {
  /**
   * @param {ChestItem} value
   * @param {ChestItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ChestItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasItemAmountMin() {
    if (this._cachedHasItemAmountMin === undefined) {
      if (this._value.hasItemAmountMin) {
        this._cachedHasItemAmountMin = true;
      } else {
        this._cachedHasItemAmountMin = this._parent ? this._parent.hasItemAmountMin : false;
      }
    }
    return this._cachedHasItemAmountMin;
  }
  get itemAmountMin() {
    if (this._cachedItemAmountMin === undefined) {
      if (this._value.hasItemAmountMin) {
        this._cachedItemAmountMin = this._value.itemAmountMin;
      } else {
        this._cachedItemAmountMin = this._parent ? this._parent.itemAmountMin : this._value.itemAmountMin;
      }
    }
    return this._cachedItemAmountMin;
  }
  get hasItemAmountMax() {
    if (this._cachedHasItemAmountMax === undefined) {
      if (this._value.hasItemAmountMax) {
        this._cachedHasItemAmountMax = true;
      } else {
        this._cachedHasItemAmountMax = this._parent ? this._parent.hasItemAmountMax : false;
      }
    }
    return this._cachedHasItemAmountMax;
  }
  get itemAmountMax() {
    if (this._cachedItemAmountMax === undefined) {
      if (this._value.hasItemAmountMax) {
        this._cachedItemAmountMax = this._value.itemAmountMax;
      } else {
        this._cachedItemAmountMax = this._parent ? this._parent.itemAmountMax : this._value.itemAmountMax;
      }
    }
    return this._cachedItemAmountMax;
  }
  get hasChanceWeight() {
    if (this._cachedHasChanceWeight === undefined) {
      if (this._value.hasChanceWeight) {
        this._cachedHasChanceWeight = true;
      } else {
        this._cachedHasChanceWeight = this._parent ? this._parent.hasChanceWeight : false;
      }
    }
    return this._cachedHasChanceWeight;
  }
  get chanceWeight() {
    if (this._cachedChanceWeight === undefined) {
      if (this._value.hasChanceWeight) {
        this._cachedChanceWeight = this._value.chanceWeight;
      } else {
        this._cachedChanceWeight = this._parent ? this._parent.chanceWeight : this._value.chanceWeight;
      }
    }
    return this._cachedChanceWeight;
  }
  get selfChanceWeightOverwriteInXTenDraws() {
    return this._value.chanceWeightOverwriteInXTenDraws;
  }
  get inherentChanceWeightOverwriteInXTenDraws() {
    if (!this._inherentChanceWeightOverwriteInXTenDraws) {
      this._inherentChanceWeightOverwriteInXTenDraws = this._parent ? this._parent.chanceWeightOverwriteInXTenDraws : [];
    }
    return this._inherentChanceWeightOverwriteInXTenDraws;
  }
  get chanceWeightOverwriteInXTenDraws() {
    if (!this._allChanceWeightOverwriteInXTenDraws) {
      this._allChanceWeightOverwriteInXTenDraws = this._parent ? this._parent.chanceWeightOverwriteInXTenDraws.concat(this.selfChanceWeightOverwriteInXTenDraws) : this.selfChanceWeightOverwriteInXTenDraws;
    }
    return this._allChanceWeightOverwriteInXTenDraws;
  }
  get hasUseXTenDrawWhenGetPromoted() {
    if (this._cachedHasUseXTenDrawWhenGetPromoted === undefined) {
      if (this._value.hasUseXTenDrawWhenGetPromoted) {
        this._cachedHasUseXTenDrawWhenGetPromoted = true;
      } else {
        this._cachedHasUseXTenDrawWhenGetPromoted = this._parent ? this._parent.hasUseXTenDrawWhenGetPromoted : false;
      }
    }
    return this._cachedHasUseXTenDrawWhenGetPromoted;
  }
  get useXTenDrawWhenGetPromoted() {
    if (this._cachedUseXTenDrawWhenGetPromoted === undefined) {
      if (this._value.hasUseXTenDrawWhenGetPromoted) {
        this._cachedUseXTenDrawWhenGetPromoted = this._value.useXTenDrawWhenGetPromoted;
      } else {
        this._cachedUseXTenDrawWhenGetPromoted = this._parent ? this._parent.useXTenDrawWhenGetPromoted : this._value.useXTenDrawWhenGetPromoted;
      }
    }
    return this._cachedUseXTenDrawWhenGetPromoted;
  }
  get hasIsPromotedItem() {
    if (this._cachedHasIsPromotedItem === undefined) {
      if (this._value.hasIsPromotedItem) {
        this._cachedHasIsPromotedItem = true;
      } else {
        this._cachedHasIsPromotedItem = this._parent ? this._parent.hasIsPromotedItem : false;
      }
    }
    return this._cachedHasIsPromotedItem;
  }
  get isPromotedItem() {
    if (this._cachedIsPromotedItem === undefined) {
      if (this._value.hasIsPromotedItem) {
        this._cachedIsPromotedItem = this._value.isPromotedItem;
      } else {
        this._cachedIsPromotedItem = this._parent ? this._parent.isPromotedItem : this._value.isPromotedItem;
      }
    }
    return this._cachedIsPromotedItem;
  }
  get hasAdditiveChanceWeightPerDraw() {
    if (this._cachedHasAdditiveChanceWeightPerDraw === undefined) {
      if (this._value.hasAdditiveChanceWeightPerDraw) {
        this._cachedHasAdditiveChanceWeightPerDraw = true;
      } else {
        this._cachedHasAdditiveChanceWeightPerDraw = this._parent ? this._parent.hasAdditiveChanceWeightPerDraw : false;
      }
    }
    return this._cachedHasAdditiveChanceWeightPerDraw;
  }
  get additiveChanceWeightPerDraw() {
    if (this._cachedAdditiveChanceWeightPerDraw === undefined) {
      if (this._value.hasAdditiveChanceWeightPerDraw) {
        this._cachedAdditiveChanceWeightPerDraw = this._value.additiveChanceWeightPerDraw;
      } else {
        this._cachedAdditiveChanceWeightPerDraw = this._parent ? this._parent.additiveChanceWeightPerDraw : this._value.additiveChanceWeightPerDraw;
      }
    }
    return this._cachedAdditiveChanceWeightPerDraw;
  }
  get hasClearCumulativeDrawCount() {
    if (this._cachedHasClearCumulativeDrawCount === undefined) {
      if (this._value.hasClearCumulativeDrawCount) {
        this._cachedHasClearCumulativeDrawCount = true;
      } else {
        this._cachedHasClearCumulativeDrawCount = this._parent ? this._parent.hasClearCumulativeDrawCount : false;
      }
    }
    return this._cachedHasClearCumulativeDrawCount;
  }
  get clearCumulativeDrawCount() {
    if (this._cachedClearCumulativeDrawCount === undefined) {
      if (this._value.hasClearCumulativeDrawCount) {
        this._cachedClearCumulativeDrawCount = this._value.clearCumulativeDrawCount;
      } else {
        this._cachedClearCumulativeDrawCount = this._parent ? this._parent.clearCumulativeDrawCount : this._value.clearCumulativeDrawCount;
      }
    }
    return this._cachedClearCumulativeDrawCount;
  }
  get hasDisplayText() {
    if (this._cachedHasDisplayText === undefined) {
      if (this._value.hasDisplayText) {
        this._cachedHasDisplayText = true;
      } else {
        this._cachedHasDisplayText = this._parent ? this._parent.hasDisplayText : false;
      }
    }
    return this._cachedHasDisplayText;
  }
  get displayText() {
    if (this._cachedDisplayText === undefined) {
      if (this._value.hasDisplayText) {
        this._cachedDisplayText = this._value.displayText;
      } else {
        this._cachedDisplayText = this._parent ? this._parent.displayText : this._value.displayText;
      }
    }
    return this._cachedDisplayText;
  }
  get hasDisplayDropRate() {
    if (this._cachedHasDisplayDropRate === undefined) {
      if (this._value.hasDisplayDropRate) {
        this._cachedHasDisplayDropRate = true;
      } else {
        this._cachedHasDisplayDropRate = this._parent ? this._parent.hasDisplayDropRate : false;
      }
    }
    return this._cachedHasDisplayDropRate;
  }
  get displayDropRate() {
    if (this._cachedDisplayDropRate === undefined) {
      if (this._value.hasDisplayDropRate) {
        this._cachedDisplayDropRate = this._value.displayDropRate;
      } else {
        this._cachedDisplayDropRate = this._parent ? this._parent.displayDropRate : this._value.displayDropRate;
      }
    }
    return this._cachedDisplayDropRate;
  }
  update(current, parent) {
    const result = new ChestItem_WithParent(current, parent);
    return result;
  }
}
ChestItem_WithParent.default = new ChestItem_WithParent(ChestItem.default, null);
ChestItem.WithParent = ChestItem_WithParent;
class ChestItem_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get itemAmountMin() {
    if (!this._itemAmountMin) {
      this._itemAmountMin = {
        name: "itemAmountMin",
        Name: "ItemAmountMin",
        number: 2,
        protoType: 5,
        protoName: "item_amount_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemAmountMin;
  }
  get itemAmountMax() {
    if (!this._itemAmountMax) {
      this._itemAmountMax = {
        name: "itemAmountMax",
        Name: "ItemAmountMax",
        number: 3,
        protoType: 5,
        protoName: "item_amount_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemAmountMax;
  }
  get chanceWeight() {
    if (!this._chanceWeight) {
      this._chanceWeight = {
        name: "chanceWeight",
        Name: "ChanceWeight",
        number: 4,
        protoType: 1,
        protoName: "chance_weight",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chanceWeight;
  }
  get chanceWeightOverwriteInXTenDraws() {
    if (!this._chanceWeightOverwriteInXTenDraws) {
      this._chanceWeightOverwriteInXTenDraws = {
        name: "chanceWeightOverwriteInXTenDraws",
        Name: "ChanceWeightOverwriteInXTenDraws",
        number: 6,
        protoType: 1,
        protoName: "chance_weight_overwrite_in_x_ten_draws",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chanceWeightOverwriteInXTenDraws;
  }
  get useXTenDrawWhenGetPromoted() {
    if (!this._useXTenDrawWhenGetPromoted) {
      this._useXTenDrawWhenGetPromoted = {
        name: "useXTenDrawWhenGetPromoted",
        Name: "UseXTenDrawWhenGetPromoted",
        number: 12,
        protoType: 5,
        protoName: "use_x_ten_draw_when_get_promoted",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useXTenDrawWhenGetPromoted;
  }
  get isPromotedItem() {
    if (!this._isPromotedItem) {
      this._isPromotedItem = {
        name: "isPromotedItem",
        Name: "IsPromotedItem",
        number: 7,
        protoType: 8,
        protoName: "is_promoted_item",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isPromotedItem;
  }
  get additiveChanceWeightPerDraw() {
    if (!this._additiveChanceWeightPerDraw) {
      this._additiveChanceWeightPerDraw = {
        name: "additiveChanceWeightPerDraw",
        Name: "AdditiveChanceWeightPerDraw",
        number: 8,
        protoType: 1,
        protoName: "additive_chance_weight_per_draw",
        type: JsonToDouble,
        options: {
          comments: "this value will be added to the original chance weight of the target item when promotion calculation begins",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._additiveChanceWeightPerDraw;
  }
  get clearCumulativeDrawCount() {
    if (!this._clearCumulativeDrawCount) {
      this._clearCumulativeDrawCount = {
        name: "clearCumulativeDrawCount",
        Name: "ClearCumulativeDrawCount",
        number: 9,
        protoType: 8,
        protoName: "clear_cumulative_draw_count",
        type: JsonToBoolean,
        options: {
          comments: "if ture, cummulatice draw count will be cleared when players get the item",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clearCumulativeDrawCount;
  }
  get displayText() {
    if (!this._displayText) {
      this._displayText = {
        name: "displayText",
        Name: "DisplayText",
        number: 10,
        protoType: 9,
        protoName: "display_text",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayText;
  }
  get displayDropRate() {
    if (!this._displayDropRate) {
      this._displayDropRate = {
        name: "displayDropRate",
        Name: "DisplayDropRate",
        number: 11,
        protoType: 1,
        protoName: "display_drop_rate",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayDropRate;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.itemAmountMin,
        this.itemAmountMax,
        this.chanceWeight,
        this.chanceWeightOverwriteInXTenDraws,
        this.useXTenDrawWhenGetPromoted,
        this.isPromotedItem,
        this.additiveChanceWeightPerDraw,
        this.clearCumulativeDrawCount,
        this.displayText,
        this.displayDropRate,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItemAmountMin",
        Name: "DummyOneofForItemAmountMin",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItemAmountMax",
        Name: "DummyOneofForItemAmountMax",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChanceWeight",
        Name: "DummyOneofForChanceWeight",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseXTenDrawWhenGetPromoted",
        Name: "DummyOneofForUseXTenDrawWhenGetPromoted",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsPromotedItem",
        Name: "DummyOneofForIsPromotedItem",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAdditiveChanceWeightPerDraw",
        Name: "DummyOneofForAdditiveChanceWeightPerDraw",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForClearCumulativeDrawCount",
        Name: "DummyOneofForClearCumulativeDrawCount",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayText",
        Name: "DummyOneofForDisplayText",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayDropRate",
        Name: "DummyOneofForDisplayDropRate",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
ChestItem.descriptor = new ChestItem_Descriptor();
export class ChestSlot {
  get descriptor() {
    return ChestSlot.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemCandidates = [];
  }
  isEmpty() {
    if (this._itemCandidates.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ChestSlot) {
      return value;
    }
    return ChestSlot.fromJson(value);
  }
  static fromJson(json) {
    const result = new ChestSlot();
    result._itemCandidates = JsonToList(json.itemCandidates, ChestItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._itemCandidates.length > 0) {
      result.itemCandidates = ArrayToJson(this._itemCandidates, ChestItem);
    }
    return result;
  }
  /**
   * @returns {ChestItem[]}
   */
  get itemCandidates() {
    return this._itemCandidates;
  }
  addItemCandidates(path, value) {
    return {type: 'ADD', path: path.concat(['itemCandidates']), value: value.toJson()};
  }
  setItemCandidates(path, value) {
    return {type: 'SET', path: path.concat(['itemCandidates']), value: ArrayToJson(value, ChestItem)};
  }
  setItemCandidatesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['itemCandidates', key]), value: value.toJson()};
  }
  deleteItemCandidates(path) {
    return {type: 'DELETE', path: path.concat(['itemCandidates'])};
  }
  deleteItemCandidatesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['itemCandidates', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemCandidates": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ChestSlot(this);
              copy._itemCandidates = [];        for (let i of value) {
                copy._itemCandidates.push(ChestItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ChestSlot(this);
              copy._itemCandidates = copy._itemCandidates.concat([ChestItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._itemCandidates.length === 0) {
                return this;
              }
              const copy = new ChestSlot(this);
              copy._itemCandidates = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._itemCandidates.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ChestSlot(this);
              copy._itemCandidates = copy._itemCandidates.slice();
              copy._itemCandidates[path[1]] = ChestItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ChestSlot(this);
              copy._itemCandidates = copy._itemCandidates.slice(0, path[1]).concat(copy._itemCandidates.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._itemCandidates.length) {
            return this;
          }
          const oldValue = this._itemCandidates[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ChestSlot(this);
          copy._itemCandidates = copy._itemCandidates.slice();
          copy._itemCandidates[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ChestSlot} other
   * @returns {ChestSlot}
   */
  merge(other) {
    const copy = new ChestSlot(this);
    copy._itemCandidates = this._itemCandidates.concat(other._itemCandidates);
    return copy;
  }
}
ChestSlot.default = new ChestSlot();
class ChestSlot_Builder {
  constructor(value) {
    this._value = new ChestSlot(value);
  }
  build() {
    return new ChestSlot(this._value);
  }
  addAllItemCandidates(values) {
    this._value._itemCandidates = this._value._itemCandidates.concat(values);
    return this;
  }
  addItemCandidates(value) {
    this._value._itemCandidates = this._value._itemCandidates.concat([value]);
    return this;
  }
  setItemCandidates(index, value) {
    this._value._itemCandidates = this._value._itemCandidates.concat();
    this._value._itemCandidates[index] = value;
    return this;
  }
  clearItemCandidates() {
    this._value._itemCandidates = [];
    return this;
  }
}
ChestSlot.Builder = ChestSlot_Builder;
class ChestSlot_WithParent {
  /**
   * @param {ChestSlot} value
   * @param {ChestSlot_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ChestSlot.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItemCandidates() {
    if (!this._selfItemCandidates) {
      this._selfItemCandidates = [];
      for (let i of this._value.itemCandidates) {
        this._selfItemCandidates.push(new ChestItem.WithParent(i, null));
      }
    }
    return this._selfItemCandidates;
  }
  get inherentItemCandidates() {
    if (!this._inherentItemCandidates) {
      this._inherentItemCandidates = this._parent ? this._parent.itemCandidates : [];
    }
    return this._inherentItemCandidates;
  }
  get itemCandidates() {
    if (!this._allItemCandidates) {
      this._allItemCandidates = this._parent ? this._parent.itemCandidates.concat(this.selfItemCandidates) : this.selfItemCandidates;
    }
    return this._allItemCandidates;
  }
  update(current, parent) {
    const result = new ChestSlot_WithParent(current, parent);
    if (this._selfItemCandidates) {
      if (this._value.itemCandidates === current.itemCandidates) {
        result._selfItemCandidates = this._selfItemCandidates;
      } else {
        result._selfItemCandidates = [];
        for (let i = 0; i < current.itemCandidates.length; i++) {
          const oldValue = this._value.itemCandidates[i];
          if (oldValue) {
            const oldCache = this._selfItemCandidates[i];
            if (oldValue === current.itemCandidates[i]) {
              result._selfItemCandidates[i] = oldCache;
            } else {
              result._selfItemCandidates[i] = oldCache.update(current.itemCandidates[i], null);
            }
          } else {
            result._selfItemCandidates[i] = new ChestItem.WithParent(current.itemCandidates[i], null);
          }
        }
      }
    }
    return result;
  }
}
ChestSlot_WithParent.default = new ChestSlot_WithParent(ChestSlot.default, null);
ChestSlot.WithParent = ChestSlot_WithParent;
class ChestSlot_Descriptor {
  get itemCandidates() {
    if (!this._itemCandidates) {
      this._itemCandidates = {
        name: "itemCandidates",
        Name: "ItemCandidates",
        number: 1,
        protoType: 11,
        protoName: "item_candidates",
        type: ChestItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemCandidates;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemCandidates,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ChestSlot.descriptor = new ChestSlot_Descriptor();
class Chest_DisplayMessage {
  get descriptor() {
    return Chest_DisplayMessage.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasInvenotryItem = false;
    this._invenotryItem = null;
    this._hasText = false;
    this._text = null;
    this._hasGuarantee = false;
    this._guarantee = null;
    this._hasPostTenDraw = false;
    this._postTenDraw = null;
    this._hasOverrideIcon = false;
    this._overrideIcon = null;
    this._hasOverrideItemDescription = false;
    this._overrideItemDescription = null;
    this._hasOverrideItemDescriptionBody = false;
    this._overrideItemDescriptionBody = null;
  }
  isEmpty() {
    if (this._hasInvenotryItem) return false;
    if (this._hasText) return false;
    if (this._hasGuarantee) return false;
    if (this._hasPostTenDraw) return false;
    if (this._hasOverrideIcon) return false;
    if (this._hasOverrideItemDescription) return false;
    if (this._hasOverrideItemDescriptionBody) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Chest_DisplayMessage) {
      return value;
    }
    return Chest_DisplayMessage.fromJson(value);
  }
  static fromJson(json) {
    const result = new Chest_DisplayMessage();
    if (json.invenotryItem != null) {
      result._hasInvenotryItem = true;
      result._invenotryItem = JsonToString.fromJson(json.invenotryItem);
    }
    if (json.text != null) {
      result._hasText = true;
      result._text = JsonToString.fromJson(json.text);
    }
    if (json.guarantee != null) {
      result._hasGuarantee = true;
      result._guarantee = JsonToBoolean.fromJson(json.guarantee);
    }
    if (json.postTenDraw != null) {
      result._hasPostTenDraw = true;
      result._postTenDraw = JsonToBoolean.fromJson(json.postTenDraw);
    }
    if (json.overrideIcon != null) {
      result._hasOverrideIcon = true;
      result._overrideIcon = JsonToString.fromJson(json.overrideIcon);
    }
    if (json.overrideItemDescription != null) {
      result._hasOverrideItemDescription = true;
      result._overrideItemDescription = JsonToString.fromJson(json.overrideItemDescription);
    }
    if (json.overrideItemDescriptionBody != null) {
      result._hasOverrideItemDescriptionBody = true;
      result._overrideItemDescriptionBody = JsonToString.fromJson(json.overrideItemDescriptionBody);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasInvenotryItem) {
      result.invenotryItem = JsonToString.toJson(this._invenotryItem);
    }
    if (this._hasText) {
      result.text = JsonToString.toJson(this._text);
    }
    if (this._hasGuarantee) {
      result.guarantee = JsonToBoolean.toJson(this._guarantee);
    }
    if (this._hasPostTenDraw) {
      result.postTenDraw = JsonToBoolean.toJson(this._postTenDraw);
    }
    if (this._hasOverrideIcon) {
      result.overrideIcon = JsonToString.toJson(this._overrideIcon);
    }
    if (this._hasOverrideItemDescription) {
      result.overrideItemDescription = JsonToString.toJson(this._overrideItemDescription);
    }
    if (this._hasOverrideItemDescriptionBody) {
      result.overrideItemDescriptionBody = JsonToString.toJson(this._overrideItemDescriptionBody);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get invenotryItem() {
    return this._hasInvenotryItem ? this._invenotryItem : JsonToString.default;
  }
  get hasInvenotryItem() {
    return this._hasInvenotryItem;
  }
  setInvenotryItem(path, value) {
    return {type: 'SET', path: path.concat(['invenotryItem']), value};
  }
  deleteInvenotryItem(path) {
    return {type: 'DELETE', path: path.concat(['invenotryItem'])};
  }
  /**
   * @returns {string}
   */
  get text() {
    return this._hasText ? this._text : JsonToString.default;
  }
  get hasText() {
    return this._hasText;
  }
  setText(path, value) {
    return {type: 'SET', path: path.concat(['text']), value};
  }
  deleteText(path) {
    return {type: 'DELETE', path: path.concat(['text'])};
  }
  /**
   * @returns {boolean}
   */
  get guarantee() {
    return this._hasGuarantee ? this._guarantee : JsonToBoolean.default;
  }
  get hasGuarantee() {
    return this._hasGuarantee;
  }
  setGuarantee(path, value) {
    return {type: 'SET', path: path.concat(['guarantee']), value};
  }
  deleteGuarantee(path) {
    return {type: 'DELETE', path: path.concat(['guarantee'])};
  }
  /**
   * @returns {boolean}
   */
  get postTenDraw() {
    return this._hasPostTenDraw ? this._postTenDraw : JsonToBoolean.default;
  }
  get hasPostTenDraw() {
    return this._hasPostTenDraw;
  }
  setPostTenDraw(path, value) {
    return {type: 'SET', path: path.concat(['postTenDraw']), value};
  }
  deletePostTenDraw(path) {
    return {type: 'DELETE', path: path.concat(['postTenDraw'])};
  }
  /**
   * @returns {string}
   */
  get overrideIcon() {
    return this._hasOverrideIcon ? this._overrideIcon : JsonToString.default;
  }
  get hasOverrideIcon() {
    return this._hasOverrideIcon;
  }
  setOverrideIcon(path, value) {
    return {type: 'SET', path: path.concat(['overrideIcon']), value};
  }
  deleteOverrideIcon(path) {
    return {type: 'DELETE', path: path.concat(['overrideIcon'])};
  }
  /**
   * @returns {string}
   */
  get overrideItemDescription() {
    return this._hasOverrideItemDescription ? this._overrideItemDescription : JsonToString.default;
  }
  get hasOverrideItemDescription() {
    return this._hasOverrideItemDescription;
  }
  setOverrideItemDescription(path, value) {
    return {type: 'SET', path: path.concat(['overrideItemDescription']), value};
  }
  deleteOverrideItemDescription(path) {
    return {type: 'DELETE', path: path.concat(['overrideItemDescription'])};
  }
  /**
   * @returns {string}
   */
  get overrideItemDescriptionBody() {
    return this._hasOverrideItemDescriptionBody ? this._overrideItemDescriptionBody : JsonToString.default;
  }
  get hasOverrideItemDescriptionBody() {
    return this._hasOverrideItemDescriptionBody;
  }
  setOverrideItemDescriptionBody(path, value) {
    return {type: 'SET', path: path.concat(['overrideItemDescriptionBody']), value};
  }
  deleteOverrideItemDescriptionBody(path) {
    return {type: 'DELETE', path: path.concat(['overrideItemDescriptionBody'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "invenotryItem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_DisplayMessage(this);
              copy._hasInvenotryItem = true;
              copy._invenotryItem = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInvenotryItem) {
                return this;
              }
              const copy = new Chest_DisplayMessage(this);
              copy._hasInvenotryItem = false;
              copy._invenotryItem = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "text": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_DisplayMessage(this);
              copy._hasText = true;
              copy._text = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasText) {
                return this;
              }
              const copy = new Chest_DisplayMessage(this);
              copy._hasText = false;
              copy._text = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "guarantee": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_DisplayMessage(this);
              copy._hasGuarantee = true;
              copy._guarantee = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuarantee) {
                return this;
              }
              const copy = new Chest_DisplayMessage(this);
              copy._hasGuarantee = false;
              copy._guarantee = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "postTenDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_DisplayMessage(this);
              copy._hasPostTenDraw = true;
              copy._postTenDraw = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPostTenDraw) {
                return this;
              }
              const copy = new Chest_DisplayMessage(this);
              copy._hasPostTenDraw = false;
              copy._postTenDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "overrideIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_DisplayMessage(this);
              copy._hasOverrideIcon = true;
              copy._overrideIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOverrideIcon) {
                return this;
              }
              const copy = new Chest_DisplayMessage(this);
              copy._hasOverrideIcon = false;
              copy._overrideIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "overrideItemDescription": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_DisplayMessage(this);
              copy._hasOverrideItemDescription = true;
              copy._overrideItemDescription = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOverrideItemDescription) {
                return this;
              }
              const copy = new Chest_DisplayMessage(this);
              copy._hasOverrideItemDescription = false;
              copy._overrideItemDescription = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "overrideItemDescriptionBody": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_DisplayMessage(this);
              copy._hasOverrideItemDescriptionBody = true;
              copy._overrideItemDescriptionBody = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOverrideItemDescriptionBody) {
                return this;
              }
              const copy = new Chest_DisplayMessage(this);
              copy._hasOverrideItemDescriptionBody = false;
              copy._overrideItemDescriptionBody = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Chest_DisplayMessage} other
   * @returns {Chest_DisplayMessage}
   */
  merge(other) {
    const copy = new Chest_DisplayMessage(this);
    if (other._hasInvenotryItem) {
      copy._hasInvenotryItem = true;
      copy._invenotryItem = other._invenotryItem;
    }
    if (other._hasText) {
      copy._hasText = true;
      copy._text = other._text;
    }
    if (other._hasGuarantee) {
      copy._hasGuarantee = true;
      copy._guarantee = other._guarantee;
    }
    if (other._hasPostTenDraw) {
      copy._hasPostTenDraw = true;
      copy._postTenDraw = other._postTenDraw;
    }
    if (other._hasOverrideIcon) {
      copy._hasOverrideIcon = true;
      copy._overrideIcon = other._overrideIcon;
    }
    if (other._hasOverrideItemDescription) {
      copy._hasOverrideItemDescription = true;
      copy._overrideItemDescription = other._overrideItemDescription;
    }
    if (other._hasOverrideItemDescriptionBody) {
      copy._hasOverrideItemDescriptionBody = true;
      copy._overrideItemDescriptionBody = other._overrideItemDescriptionBody;
    }
    return copy;
  }
}
Chest_DisplayMessage.default = new Chest_DisplayMessage();
class Chest_DisplayMessage_Builder {
  constructor(value) {
    this._value = new Chest_DisplayMessage(value);
  }
  build() {
    return new Chest_DisplayMessage(this._value);
  }
  setInvenotryItem(value) {
    this._value._hasInvenotryItem = true;
    this._value._invenotryItem = value;
    return this;
  }
  deleteInvenotryItem() {
    this._value._hasInvenotryItem = false;
    this._value._invenotryItem = null;
    return this;
  }
  setText(value) {
    this._value._hasText = true;
    this._value._text = value;
    return this;
  }
  deleteText() {
    this._value._hasText = false;
    this._value._text = null;
    return this;
  }
  setGuarantee(value) {
    this._value._hasGuarantee = true;
    this._value._guarantee = value;
    return this;
  }
  deleteGuarantee() {
    this._value._hasGuarantee = false;
    this._value._guarantee = null;
    return this;
  }
  setPostTenDraw(value) {
    this._value._hasPostTenDraw = true;
    this._value._postTenDraw = value;
    return this;
  }
  deletePostTenDraw() {
    this._value._hasPostTenDraw = false;
    this._value._postTenDraw = null;
    return this;
  }
  setOverrideIcon(value) {
    this._value._hasOverrideIcon = true;
    this._value._overrideIcon = value;
    return this;
  }
  deleteOverrideIcon() {
    this._value._hasOverrideIcon = false;
    this._value._overrideIcon = null;
    return this;
  }
  setOverrideItemDescription(value) {
    this._value._hasOverrideItemDescription = true;
    this._value._overrideItemDescription = value;
    return this;
  }
  deleteOverrideItemDescription() {
    this._value._hasOverrideItemDescription = false;
    this._value._overrideItemDescription = null;
    return this;
  }
  setOverrideItemDescriptionBody(value) {
    this._value._hasOverrideItemDescriptionBody = true;
    this._value._overrideItemDescriptionBody = value;
    return this;
  }
  deleteOverrideItemDescriptionBody() {
    this._value._hasOverrideItemDescriptionBody = false;
    this._value._overrideItemDescriptionBody = null;
    return this;
  }
}
Chest_DisplayMessage.Builder = Chest_DisplayMessage_Builder;
class Chest_DisplayMessage_WithParent {
  /**
   * @param {Chest_DisplayMessage} value
   * @param {Chest_DisplayMessage_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Chest_DisplayMessage.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasInvenotryItem() {
    if (this._cachedHasInvenotryItem === undefined) {
      if (this._value.hasInvenotryItem) {
        this._cachedHasInvenotryItem = true;
      } else {
        this._cachedHasInvenotryItem = this._parent ? this._parent.hasInvenotryItem : false;
      }
    }
    return this._cachedHasInvenotryItem;
  }
  get invenotryItem() {
    if (this._cachedInvenotryItem === undefined) {
      if (this._value.hasInvenotryItem) {
        this._cachedInvenotryItem = this._value.invenotryItem;
      } else {
        this._cachedInvenotryItem = this._parent ? this._parent.invenotryItem : this._value.invenotryItem;
      }
    }
    return this._cachedInvenotryItem;
  }
  get hasText() {
    if (this._cachedHasText === undefined) {
      if (this._value.hasText) {
        this._cachedHasText = true;
      } else {
        this._cachedHasText = this._parent ? this._parent.hasText : false;
      }
    }
    return this._cachedHasText;
  }
  get text() {
    if (this._cachedText === undefined) {
      if (this._value.hasText) {
        this._cachedText = this._value.text;
      } else {
        this._cachedText = this._parent ? this._parent.text : this._value.text;
      }
    }
    return this._cachedText;
  }
  get hasGuarantee() {
    if (this._cachedHasGuarantee === undefined) {
      if (this._value.hasGuarantee) {
        this._cachedHasGuarantee = true;
      } else {
        this._cachedHasGuarantee = this._parent ? this._parent.hasGuarantee : false;
      }
    }
    return this._cachedHasGuarantee;
  }
  get guarantee() {
    if (this._cachedGuarantee === undefined) {
      if (this._value.hasGuarantee) {
        this._cachedGuarantee = this._value.guarantee;
      } else {
        this._cachedGuarantee = this._parent ? this._parent.guarantee : this._value.guarantee;
      }
    }
    return this._cachedGuarantee;
  }
  get hasPostTenDraw() {
    if (this._cachedHasPostTenDraw === undefined) {
      if (this._value.hasPostTenDraw) {
        this._cachedHasPostTenDraw = true;
      } else {
        this._cachedHasPostTenDraw = this._parent ? this._parent.hasPostTenDraw : false;
      }
    }
    return this._cachedHasPostTenDraw;
  }
  get postTenDraw() {
    if (this._cachedPostTenDraw === undefined) {
      if (this._value.hasPostTenDraw) {
        this._cachedPostTenDraw = this._value.postTenDraw;
      } else {
        this._cachedPostTenDraw = this._parent ? this._parent.postTenDraw : this._value.postTenDraw;
      }
    }
    return this._cachedPostTenDraw;
  }
  get hasOverrideIcon() {
    if (this._cachedHasOverrideIcon === undefined) {
      if (this._value.hasOverrideIcon) {
        this._cachedHasOverrideIcon = true;
      } else {
        this._cachedHasOverrideIcon = this._parent ? this._parent.hasOverrideIcon : false;
      }
    }
    return this._cachedHasOverrideIcon;
  }
  get overrideIcon() {
    if (this._cachedOverrideIcon === undefined) {
      if (this._value.hasOverrideIcon) {
        this._cachedOverrideIcon = this._value.overrideIcon;
      } else {
        this._cachedOverrideIcon = this._parent ? this._parent.overrideIcon : this._value.overrideIcon;
      }
    }
    return this._cachedOverrideIcon;
  }
  get hasOverrideItemDescription() {
    if (this._cachedHasOverrideItemDescription === undefined) {
      if (this._value.hasOverrideItemDescription) {
        this._cachedHasOverrideItemDescription = true;
      } else {
        this._cachedHasOverrideItemDescription = this._parent ? this._parent.hasOverrideItemDescription : false;
      }
    }
    return this._cachedHasOverrideItemDescription;
  }
  get overrideItemDescription() {
    if (this._cachedOverrideItemDescription === undefined) {
      if (this._value.hasOverrideItemDescription) {
        this._cachedOverrideItemDescription = this._value.overrideItemDescription;
      } else {
        this._cachedOverrideItemDescription = this._parent ? this._parent.overrideItemDescription : this._value.overrideItemDescription;
      }
    }
    return this._cachedOverrideItemDescription;
  }
  get hasOverrideItemDescriptionBody() {
    if (this._cachedHasOverrideItemDescriptionBody === undefined) {
      if (this._value.hasOverrideItemDescriptionBody) {
        this._cachedHasOverrideItemDescriptionBody = true;
      } else {
        this._cachedHasOverrideItemDescriptionBody = this._parent ? this._parent.hasOverrideItemDescriptionBody : false;
      }
    }
    return this._cachedHasOverrideItemDescriptionBody;
  }
  get overrideItemDescriptionBody() {
    if (this._cachedOverrideItemDescriptionBody === undefined) {
      if (this._value.hasOverrideItemDescriptionBody) {
        this._cachedOverrideItemDescriptionBody = this._value.overrideItemDescriptionBody;
      } else {
        this._cachedOverrideItemDescriptionBody = this._parent ? this._parent.overrideItemDescriptionBody : this._value.overrideItemDescriptionBody;
      }
    }
    return this._cachedOverrideItemDescriptionBody;
  }
  update(current, parent) {
    const result = new Chest_DisplayMessage_WithParent(current, parent);
    return result;
  }
}
Chest_DisplayMessage_WithParent.default = new Chest_DisplayMessage_WithParent(Chest_DisplayMessage.default, null);
Chest_DisplayMessage.WithParent = Chest_DisplayMessage_WithParent;
class Chest_DisplayMessage_Descriptor {
  get invenotryItem() {
    if (!this._invenotryItem) {
      this._invenotryItem = {
        name: "invenotryItem",
        Name: "InvenotryItem",
        number: 1,
        protoType: 9,
        protoName: "invenotry_item",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._invenotryItem;
  }
  get text() {
    if (!this._text) {
      this._text = {
        name: "text",
        Name: "Text",
        number: 2,
        protoType: 9,
        protoName: "text",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._text;
  }
  get guarantee() {
    if (!this._guarantee) {
      this._guarantee = {
        name: "guarantee",
        Name: "Guarantee",
        number: 3,
        protoType: 8,
        protoName: "guarantee",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guarantee;
  }
  get postTenDraw() {
    if (!this._postTenDraw) {
      this._postTenDraw = {
        name: "postTenDraw",
        Name: "PostTenDraw",
        number: 7,
        protoType: 8,
        protoName: "post_ten_draw",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._postTenDraw;
  }
  get overrideIcon() {
    if (!this._overrideIcon) {
      this._overrideIcon = {
        name: "overrideIcon",
        Name: "OverrideIcon",
        number: 4,
        protoType: 9,
        protoName: "override_icon",
        type: JsonToString,
        options: {
          valueDropdown: "InventoryItemIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._overrideIcon;
  }
  get overrideItemDescription() {
    if (!this._overrideItemDescription) {
      this._overrideItemDescription = {
        name: "overrideItemDescription",
        Name: "OverrideItemDescription",
        number: 5,
        protoType: 9,
        protoName: "override_item_description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._overrideItemDescription;
  }
  get overrideItemDescriptionBody() {
    if (!this._overrideItemDescriptionBody) {
      this._overrideItemDescriptionBody = {
        name: "overrideItemDescriptionBody",
        Name: "OverrideItemDescriptionBody",
        number: 6,
        protoType: 9,
        protoName: "override_item_description_body",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._overrideItemDescriptionBody;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.invenotryItem,
        this.text,
        this.guarantee,
        this.postTenDraw,
        this.overrideIcon,
        this.overrideItemDescription,
        this.overrideItemDescriptionBody,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForInvenotryItem",
        Name: "DummyOneofForInvenotryItem",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForText",
        Name: "DummyOneofForText",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGuarantee",
        Name: "DummyOneofForGuarantee",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPostTenDraw",
        Name: "DummyOneofForPostTenDraw",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOverrideIcon",
        Name: "DummyOneofForOverrideIcon",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOverrideItemDescription",
        Name: "DummyOneofForOverrideItemDescription",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOverrideItemDescriptionBody",
        Name: "DummyOneofForOverrideItemDescriptionBody",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
Chest_DisplayMessage.descriptor = new Chest_DisplayMessage_Descriptor();
class Chest_GuaranteeRewardCandidate {
  get descriptor() {
    return Chest_GuaranteeRewardCandidate.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasItemAmount = false;
    this._itemAmount = null;
    this._hasChanceWeight = false;
    this._chanceWeight = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasItemAmount) return false;
    if (this._hasChanceWeight) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Chest_GuaranteeRewardCandidate) {
      return value;
    }
    return Chest_GuaranteeRewardCandidate.fromJson(value);
  }
  static fromJson(json) {
    const result = new Chest_GuaranteeRewardCandidate();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.itemAmount != null) {
      result._hasItemAmount = true;
      result._itemAmount = JsonToInt32.fromJson(json.itemAmount);
    }
    if (json.chanceWeight != null) {
      result._hasChanceWeight = true;
      result._chanceWeight = JsonToDouble.fromJson(json.chanceWeight);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasItemAmount) {
      result.itemAmount = JsonToInt32.toJson(this._itemAmount);
    }
    if (this._hasChanceWeight) {
      result.chanceWeight = JsonToDouble.toJson(this._chanceWeight);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get itemAmount() {
    return this._hasItemAmount ? this._itemAmount : JsonToInt32.default;
  }
  get hasItemAmount() {
    return this._hasItemAmount;
  }
  setItemAmount(path, value) {
    return {type: 'SET', path: path.concat(['itemAmount']), value};
  }
  deleteItemAmount(path) {
    return {type: 'DELETE', path: path.concat(['itemAmount'])};
  }
  /**
   * @returns {number}
   */
  get chanceWeight() {
    return this._hasChanceWeight ? this._chanceWeight : JsonToDouble.default;
  }
  get hasChanceWeight() {
    return this._hasChanceWeight;
  }
  setChanceWeight(path, value) {
    return {type: 'SET', path: path.concat(['chanceWeight']), value};
  }
  deleteChanceWeight(path) {
    return {type: 'DELETE', path: path.concat(['chanceWeight'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_GuaranteeRewardCandidate(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new Chest_GuaranteeRewardCandidate(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "itemAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_GuaranteeRewardCandidate(this);
              copy._hasItemAmount = true;
              copy._itemAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemAmount) {
                return this;
              }
              const copy = new Chest_GuaranteeRewardCandidate(this);
              copy._hasItemAmount = false;
              copy._itemAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chanceWeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_GuaranteeRewardCandidate(this);
              copy._hasChanceWeight = true;
              copy._chanceWeight = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChanceWeight) {
                return this;
              }
              const copy = new Chest_GuaranteeRewardCandidate(this);
              copy._hasChanceWeight = false;
              copy._chanceWeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Chest_GuaranteeRewardCandidate} other
   * @returns {Chest_GuaranteeRewardCandidate}
   */
  merge(other) {
    const copy = new Chest_GuaranteeRewardCandidate(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasItemAmount) {
      copy._hasItemAmount = true;
      copy._itemAmount = other._itemAmount;
    }
    if (other._hasChanceWeight) {
      copy._hasChanceWeight = true;
      copy._chanceWeight = other._chanceWeight;
    }
    return copy;
  }
}
Chest_GuaranteeRewardCandidate.default = new Chest_GuaranteeRewardCandidate();
class Chest_GuaranteeRewardCandidate_Builder {
  constructor(value) {
    this._value = new Chest_GuaranteeRewardCandidate(value);
  }
  build() {
    return new Chest_GuaranteeRewardCandidate(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setItemAmount(value) {
    this._value._hasItemAmount = true;
    this._value._itemAmount = value;
    return this;
  }
  deleteItemAmount() {
    this._value._hasItemAmount = false;
    this._value._itemAmount = null;
    return this;
  }
  setChanceWeight(value) {
    this._value._hasChanceWeight = true;
    this._value._chanceWeight = value;
    return this;
  }
  deleteChanceWeight() {
    this._value._hasChanceWeight = false;
    this._value._chanceWeight = null;
    return this;
  }
}
Chest_GuaranteeRewardCandidate.Builder = Chest_GuaranteeRewardCandidate_Builder;
class Chest_GuaranteeRewardCandidate_WithParent {
  /**
   * @param {Chest_GuaranteeRewardCandidate} value
   * @param {Chest_GuaranteeRewardCandidate_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Chest_GuaranteeRewardCandidate.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasItemAmount() {
    if (this._cachedHasItemAmount === undefined) {
      if (this._value.hasItemAmount) {
        this._cachedHasItemAmount = true;
      } else {
        this._cachedHasItemAmount = this._parent ? this._parent.hasItemAmount : false;
      }
    }
    return this._cachedHasItemAmount;
  }
  get itemAmount() {
    if (this._cachedItemAmount === undefined) {
      if (this._value.hasItemAmount) {
        this._cachedItemAmount = this._value.itemAmount;
      } else {
        this._cachedItemAmount = this._parent ? this._parent.itemAmount : this._value.itemAmount;
      }
    }
    return this._cachedItemAmount;
  }
  get hasChanceWeight() {
    if (this._cachedHasChanceWeight === undefined) {
      if (this._value.hasChanceWeight) {
        this._cachedHasChanceWeight = true;
      } else {
        this._cachedHasChanceWeight = this._parent ? this._parent.hasChanceWeight : false;
      }
    }
    return this._cachedHasChanceWeight;
  }
  get chanceWeight() {
    if (this._cachedChanceWeight === undefined) {
      if (this._value.hasChanceWeight) {
        this._cachedChanceWeight = this._value.chanceWeight;
      } else {
        this._cachedChanceWeight = this._parent ? this._parent.chanceWeight : this._value.chanceWeight;
      }
    }
    return this._cachedChanceWeight;
  }
  update(current, parent) {
    const result = new Chest_GuaranteeRewardCandidate_WithParent(current, parent);
    return result;
  }
}
Chest_GuaranteeRewardCandidate_WithParent.default = new Chest_GuaranteeRewardCandidate_WithParent(Chest_GuaranteeRewardCandidate.default, null);
Chest_GuaranteeRewardCandidate.WithParent = Chest_GuaranteeRewardCandidate_WithParent;
class Chest_GuaranteeRewardCandidate_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get itemAmount() {
    if (!this._itemAmount) {
      this._itemAmount = {
        name: "itemAmount",
        Name: "ItemAmount",
        number: 2,
        protoType: 5,
        protoName: "item_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemAmount;
  }
  get chanceWeight() {
    if (!this._chanceWeight) {
      this._chanceWeight = {
        name: "chanceWeight",
        Name: "ChanceWeight",
        number: 3,
        protoType: 1,
        protoName: "chance_weight",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chanceWeight;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.itemAmount,
        this.chanceWeight,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItemAmount",
        Name: "DummyOneofForItemAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChanceWeight",
        Name: "DummyOneofForChanceWeight",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
Chest_GuaranteeRewardCandidate.descriptor = new Chest_GuaranteeRewardCandidate_Descriptor();
class Chest_GuaranteeRewardSlot {
  get descriptor() {
    return Chest_GuaranteeRewardSlot.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemCandidates = [];
    this._hasDisplayText = false;
    this._displayText = null;
  }
  isEmpty() {
    if (this._itemCandidates.length > 0) return false;
    if (this._hasDisplayText) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Chest_GuaranteeRewardSlot) {
      return value;
    }
    return Chest_GuaranteeRewardSlot.fromJson(value);
  }
  static fromJson(json) {
    const result = new Chest_GuaranteeRewardSlot();
    result._itemCandidates = JsonToList(json.itemCandidates, Chest_GuaranteeRewardCandidate);
    if (json.displayText != null) {
      result._hasDisplayText = true;
      result._displayText = JsonToString.fromJson(json.displayText);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._itemCandidates.length > 0) {
      result.itemCandidates = ArrayToJson(this._itemCandidates, Chest_GuaranteeRewardCandidate);
    }
    if (this._hasDisplayText) {
      result.displayText = JsonToString.toJson(this._displayText);
    }
    return result;
  }
  /**
   * @returns {Chest_GuaranteeRewardCandidate[]}
   */
  get itemCandidates() {
    return this._itemCandidates;
  }
  addItemCandidates(path, value) {
    return {type: 'ADD', path: path.concat(['itemCandidates']), value: value.toJson()};
  }
  setItemCandidates(path, value) {
    return {type: 'SET', path: path.concat(['itemCandidates']), value: ArrayToJson(value, Chest_GuaranteeRewardCandidate)};
  }
  setItemCandidatesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['itemCandidates', key]), value: value.toJson()};
  }
  deleteItemCandidates(path) {
    return {type: 'DELETE', path: path.concat(['itemCandidates'])};
  }
  deleteItemCandidatesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['itemCandidates', key])};
  }
  /**
   * @returns {string}
   */
  get displayText() {
    return this._hasDisplayText ? this._displayText : JsonToString.default;
  }
  get hasDisplayText() {
    return this._hasDisplayText;
  }
  setDisplayText(path, value) {
    return {type: 'SET', path: path.concat(['displayText']), value};
  }
  deleteDisplayText(path) {
    return {type: 'DELETE', path: path.concat(['displayText'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemCandidates": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_GuaranteeRewardSlot(this);
              copy._itemCandidates = [];        for (let i of value) {
                copy._itemCandidates.push(Chest_GuaranteeRewardCandidate.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Chest_GuaranteeRewardSlot(this);
              copy._itemCandidates = copy._itemCandidates.concat([Chest_GuaranteeRewardCandidate.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._itemCandidates.length === 0) {
                return this;
              }
              const copy = new Chest_GuaranteeRewardSlot(this);
              copy._itemCandidates = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._itemCandidates.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Chest_GuaranteeRewardSlot(this);
              copy._itemCandidates = copy._itemCandidates.slice();
              copy._itemCandidates[path[1]] = Chest_GuaranteeRewardCandidate.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Chest_GuaranteeRewardSlot(this);
              copy._itemCandidates = copy._itemCandidates.slice(0, path[1]).concat(copy._itemCandidates.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._itemCandidates.length) {
            return this;
          }
          const oldValue = this._itemCandidates[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Chest_GuaranteeRewardSlot(this);
          copy._itemCandidates = copy._itemCandidates.slice();
          copy._itemCandidates[key] = newValue;
          return copy;
        }
      }
      case "displayText": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_GuaranteeRewardSlot(this);
              copy._hasDisplayText = true;
              copy._displayText = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayText) {
                return this;
              }
              const copy = new Chest_GuaranteeRewardSlot(this);
              copy._hasDisplayText = false;
              copy._displayText = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Chest_GuaranteeRewardSlot} other
   * @returns {Chest_GuaranteeRewardSlot}
   */
  merge(other) {
    const copy = new Chest_GuaranteeRewardSlot(this);
    copy._itemCandidates = this._itemCandidates.concat(other._itemCandidates);
    if (other._hasDisplayText) {
      copy._hasDisplayText = true;
      copy._displayText = other._displayText;
    }
    return copy;
  }
}
Chest_GuaranteeRewardSlot.default = new Chest_GuaranteeRewardSlot();
class Chest_GuaranteeRewardSlot_Builder {
  constructor(value) {
    this._value = new Chest_GuaranteeRewardSlot(value);
  }
  build() {
    return new Chest_GuaranteeRewardSlot(this._value);
  }
  addAllItemCandidates(values) {
    this._value._itemCandidates = this._value._itemCandidates.concat(values);
    return this;
  }
  addItemCandidates(value) {
    this._value._itemCandidates = this._value._itemCandidates.concat([value]);
    return this;
  }
  setItemCandidates(index, value) {
    this._value._itemCandidates = this._value._itemCandidates.concat();
    this._value._itemCandidates[index] = value;
    return this;
  }
  clearItemCandidates() {
    this._value._itemCandidates = [];
    return this;
  }
  setDisplayText(value) {
    this._value._hasDisplayText = true;
    this._value._displayText = value;
    return this;
  }
  deleteDisplayText() {
    this._value._hasDisplayText = false;
    this._value._displayText = null;
    return this;
  }
}
Chest_GuaranteeRewardSlot.Builder = Chest_GuaranteeRewardSlot_Builder;
class Chest_GuaranteeRewardSlot_WithParent {
  /**
   * @param {Chest_GuaranteeRewardSlot} value
   * @param {Chest_GuaranteeRewardSlot_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Chest_GuaranteeRewardSlot.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItemCandidates() {
    if (!this._selfItemCandidates) {
      this._selfItemCandidates = [];
      for (let i of this._value.itemCandidates) {
        this._selfItemCandidates.push(new Chest_GuaranteeRewardCandidate.WithParent(i, null));
      }
    }
    return this._selfItemCandidates;
  }
  get inherentItemCandidates() {
    if (!this._inherentItemCandidates) {
      this._inherentItemCandidates = this._parent ? this._parent.itemCandidates : [];
    }
    return this._inherentItemCandidates;
  }
  get itemCandidates() {
    if (!this._allItemCandidates) {
      this._allItemCandidates = this._parent ? this._parent.itemCandidates.concat(this.selfItemCandidates) : this.selfItemCandidates;
    }
    return this._allItemCandidates;
  }
  get hasDisplayText() {
    if (this._cachedHasDisplayText === undefined) {
      if (this._value.hasDisplayText) {
        this._cachedHasDisplayText = true;
      } else {
        this._cachedHasDisplayText = this._parent ? this._parent.hasDisplayText : false;
      }
    }
    return this._cachedHasDisplayText;
  }
  get displayText() {
    if (this._cachedDisplayText === undefined) {
      if (this._value.hasDisplayText) {
        this._cachedDisplayText = this._value.displayText;
      } else {
        this._cachedDisplayText = this._parent ? this._parent.displayText : this._value.displayText;
      }
    }
    return this._cachedDisplayText;
  }
  update(current, parent) {
    const result = new Chest_GuaranteeRewardSlot_WithParent(current, parent);
    if (this._selfItemCandidates) {
      if (this._value.itemCandidates === current.itemCandidates) {
        result._selfItemCandidates = this._selfItemCandidates;
      } else {
        result._selfItemCandidates = [];
        for (let i = 0; i < current.itemCandidates.length; i++) {
          const oldValue = this._value.itemCandidates[i];
          if (oldValue) {
            const oldCache = this._selfItemCandidates[i];
            if (oldValue === current.itemCandidates[i]) {
              result._selfItemCandidates[i] = oldCache;
            } else {
              result._selfItemCandidates[i] = oldCache.update(current.itemCandidates[i], null);
            }
          } else {
            result._selfItemCandidates[i] = new Chest_GuaranteeRewardCandidate.WithParent(current.itemCandidates[i], null);
          }
        }
      }
    }
    return result;
  }
}
Chest_GuaranteeRewardSlot_WithParent.default = new Chest_GuaranteeRewardSlot_WithParent(Chest_GuaranteeRewardSlot.default, null);
Chest_GuaranteeRewardSlot.WithParent = Chest_GuaranteeRewardSlot_WithParent;
class Chest_GuaranteeRewardSlot_Descriptor {
  get itemCandidates() {
    if (!this._itemCandidates) {
      this._itemCandidates = {
        name: "itemCandidates",
        Name: "ItemCandidates",
        number: 1,
        protoType: 11,
        protoName: "item_candidates",
        type: Chest_GuaranteeRewardCandidate,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemCandidates;
  }
  get displayText() {
    if (!this._displayText) {
      this._displayText = {
        name: "displayText",
        Name: "DisplayText",
        number: 2,
        protoType: 9,
        protoName: "display_text",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayText;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemCandidates,
        this.displayText,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDisplayText",
        Name: "DummyOneofForDisplayText",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Chest_GuaranteeRewardSlot.descriptor = new Chest_GuaranteeRewardSlot_Descriptor();
class Chest_TenDrawGuaranteeReward {
  get descriptor() {
    return Chest_TenDrawGuaranteeReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasXThTenDraw = false;
    this._xThTenDraw = null;
    this._itemSlots = [];
  }
  isEmpty() {
    if (this._hasXThTenDraw) return false;
    if (this._itemSlots.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Chest_TenDrawGuaranteeReward) {
      return value;
    }
    return Chest_TenDrawGuaranteeReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new Chest_TenDrawGuaranteeReward();
    if (json.xThTenDraw != null) {
      result._hasXThTenDraw = true;
      result._xThTenDraw = JsonToInt32.fromJson(json.xThTenDraw);
    }
    result._itemSlots = JsonToList(json.itemSlots, Chest_GuaranteeRewardSlot);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasXThTenDraw) {
      result.xThTenDraw = JsonToInt32.toJson(this._xThTenDraw);
    }
    if (this._itemSlots.length > 0) {
      result.itemSlots = ArrayToJson(this._itemSlots, Chest_GuaranteeRewardSlot);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get xThTenDraw() {
    return this._hasXThTenDraw ? this._xThTenDraw : JsonToInt32.default;
  }
  get hasXThTenDraw() {
    return this._hasXThTenDraw;
  }
  setXThTenDraw(path, value) {
    return {type: 'SET', path: path.concat(['xThTenDraw']), value};
  }
  deleteXThTenDraw(path) {
    return {type: 'DELETE', path: path.concat(['xThTenDraw'])};
  }
  /**
   * @returns {Chest_GuaranteeRewardSlot[]}
   */
  get itemSlots() {
    return this._itemSlots;
  }
  addItemSlots(path, value) {
    return {type: 'ADD', path: path.concat(['itemSlots']), value: value.toJson()};
  }
  setItemSlots(path, value) {
    return {type: 'SET', path: path.concat(['itemSlots']), value: ArrayToJson(value, Chest_GuaranteeRewardSlot)};
  }
  setItemSlotsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['itemSlots', key]), value: value.toJson()};
  }
  deleteItemSlots(path) {
    return {type: 'DELETE', path: path.concat(['itemSlots'])};
  }
  deleteItemSlotsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['itemSlots', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "xThTenDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_TenDrawGuaranteeReward(this);
              copy._hasXThTenDraw = true;
              copy._xThTenDraw = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXThTenDraw) {
                return this;
              }
              const copy = new Chest_TenDrawGuaranteeReward(this);
              copy._hasXThTenDraw = false;
              copy._xThTenDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "itemSlots": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_TenDrawGuaranteeReward(this);
              copy._itemSlots = [];        for (let i of value) {
                copy._itemSlots.push(Chest_GuaranteeRewardSlot.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Chest_TenDrawGuaranteeReward(this);
              copy._itemSlots = copy._itemSlots.concat([Chest_GuaranteeRewardSlot.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._itemSlots.length === 0) {
                return this;
              }
              const copy = new Chest_TenDrawGuaranteeReward(this);
              copy._itemSlots = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._itemSlots.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Chest_TenDrawGuaranteeReward(this);
              copy._itemSlots = copy._itemSlots.slice();
              copy._itemSlots[path[1]] = Chest_GuaranteeRewardSlot.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Chest_TenDrawGuaranteeReward(this);
              copy._itemSlots = copy._itemSlots.slice(0, path[1]).concat(copy._itemSlots.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._itemSlots.length) {
            return this;
          }
          const oldValue = this._itemSlots[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Chest_TenDrawGuaranteeReward(this);
          copy._itemSlots = copy._itemSlots.slice();
          copy._itemSlots[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Chest_TenDrawGuaranteeReward} other
   * @returns {Chest_TenDrawGuaranteeReward}
   */
  merge(other) {
    const copy = new Chest_TenDrawGuaranteeReward(this);
    if (other._hasXThTenDraw) {
      copy._hasXThTenDraw = true;
      copy._xThTenDraw = other._xThTenDraw;
    }
    copy._itemSlots = this._itemSlots.concat(other._itemSlots);
    return copy;
  }
}
Chest_TenDrawGuaranteeReward.default = new Chest_TenDrawGuaranteeReward();
class Chest_TenDrawGuaranteeReward_Builder {
  constructor(value) {
    this._value = new Chest_TenDrawGuaranteeReward(value);
  }
  build() {
    return new Chest_TenDrawGuaranteeReward(this._value);
  }
  setXThTenDraw(value) {
    this._value._hasXThTenDraw = true;
    this._value._xThTenDraw = value;
    return this;
  }
  deleteXThTenDraw() {
    this._value._hasXThTenDraw = false;
    this._value._xThTenDraw = null;
    return this;
  }
  addAllItemSlots(values) {
    this._value._itemSlots = this._value._itemSlots.concat(values);
    return this;
  }
  addItemSlots(value) {
    this._value._itemSlots = this._value._itemSlots.concat([value]);
    return this;
  }
  setItemSlots(index, value) {
    this._value._itemSlots = this._value._itemSlots.concat();
    this._value._itemSlots[index] = value;
    return this;
  }
  clearItemSlots() {
    this._value._itemSlots = [];
    return this;
  }
}
Chest_TenDrawGuaranteeReward.Builder = Chest_TenDrawGuaranteeReward_Builder;
class Chest_TenDrawGuaranteeReward_WithParent {
  /**
   * @param {Chest_TenDrawGuaranteeReward} value
   * @param {Chest_TenDrawGuaranteeReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Chest_TenDrawGuaranteeReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasXThTenDraw() {
    if (this._cachedHasXThTenDraw === undefined) {
      if (this._value.hasXThTenDraw) {
        this._cachedHasXThTenDraw = true;
      } else {
        this._cachedHasXThTenDraw = this._parent ? this._parent.hasXThTenDraw : false;
      }
    }
    return this._cachedHasXThTenDraw;
  }
  get xThTenDraw() {
    if (this._cachedXThTenDraw === undefined) {
      if (this._value.hasXThTenDraw) {
        this._cachedXThTenDraw = this._value.xThTenDraw;
      } else {
        this._cachedXThTenDraw = this._parent ? this._parent.xThTenDraw : this._value.xThTenDraw;
      }
    }
    return this._cachedXThTenDraw;
  }
  get selfItemSlots() {
    if (!this._selfItemSlots) {
      this._selfItemSlots = [];
      for (let i of this._value.itemSlots) {
        this._selfItemSlots.push(new Chest_GuaranteeRewardSlot.WithParent(i, null));
      }
    }
    return this._selfItemSlots;
  }
  get inherentItemSlots() {
    if (!this._inherentItemSlots) {
      this._inherentItemSlots = this._parent ? this._parent.itemSlots : [];
    }
    return this._inherentItemSlots;
  }
  get itemSlots() {
    if (!this._allItemSlots) {
      this._allItemSlots = this._parent ? this._parent.itemSlots.concat(this.selfItemSlots) : this.selfItemSlots;
    }
    return this._allItemSlots;
  }
  update(current, parent) {
    const result = new Chest_TenDrawGuaranteeReward_WithParent(current, parent);
    if (this._selfItemSlots) {
      if (this._value.itemSlots === current.itemSlots) {
        result._selfItemSlots = this._selfItemSlots;
      } else {
        result._selfItemSlots = [];
        for (let i = 0; i < current.itemSlots.length; i++) {
          const oldValue = this._value.itemSlots[i];
          if (oldValue) {
            const oldCache = this._selfItemSlots[i];
            if (oldValue === current.itemSlots[i]) {
              result._selfItemSlots[i] = oldCache;
            } else {
              result._selfItemSlots[i] = oldCache.update(current.itemSlots[i], null);
            }
          } else {
            result._selfItemSlots[i] = new Chest_GuaranteeRewardSlot.WithParent(current.itemSlots[i], null);
          }
        }
      }
    }
    return result;
  }
}
Chest_TenDrawGuaranteeReward_WithParent.default = new Chest_TenDrawGuaranteeReward_WithParent(Chest_TenDrawGuaranteeReward.default, null);
Chest_TenDrawGuaranteeReward.WithParent = Chest_TenDrawGuaranteeReward_WithParent;
class Chest_TenDrawGuaranteeReward_Descriptor {
  get xThTenDraw() {
    if (!this._xThTenDraw) {
      this._xThTenDraw = {
        name: "xThTenDraw",
        Name: "XThTenDraw",
        number: 1,
        protoType: 5,
        protoName: "x_th_ten_draw",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xThTenDraw;
  }
  get itemSlots() {
    if (!this._itemSlots) {
      this._itemSlots = {
        name: "itemSlots",
        Name: "ItemSlots",
        number: 2,
        protoType: 11,
        protoName: "item_slots",
        type: Chest_GuaranteeRewardSlot,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemSlots;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.xThTenDraw,
        this.itemSlots,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForXThTenDraw",
        Name: "DummyOneofForXThTenDraw",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
Chest_TenDrawGuaranteeReward.descriptor = new Chest_TenDrawGuaranteeReward_Descriptor();
class Chest_PromotedItem {
  get descriptor() {
    return Chest_PromotedItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAdditiveChanceWeightPerDraw = false;
    this._additiveChanceWeightPerDraw = null;
    this._hasClearCumulativeDrawCount = false;
    this._clearCumulativeDrawCount = null;
    this._hasText = false;
    this._text = null;
    this._hasDisplayDropRate = false;
    this._displayDropRate = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAdditiveChanceWeightPerDraw) return false;
    if (this._hasClearCumulativeDrawCount) return false;
    if (this._hasText) return false;
    if (this._hasDisplayDropRate) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Chest_PromotedItem) {
      return value;
    }
    return Chest_PromotedItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new Chest_PromotedItem();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.additiveChanceWeightPerDraw != null) {
      result._hasAdditiveChanceWeightPerDraw = true;
      result._additiveChanceWeightPerDraw = JsonToDouble.fromJson(json.additiveChanceWeightPerDraw);
    }
    if (json.clearCumulativeDrawCount != null) {
      result._hasClearCumulativeDrawCount = true;
      result._clearCumulativeDrawCount = JsonToBoolean.fromJson(json.clearCumulativeDrawCount);
    }
    if (json.text != null) {
      result._hasText = true;
      result._text = JsonToString.fromJson(json.text);
    }
    if (json.displayDropRate != null) {
      result._hasDisplayDropRate = true;
      result._displayDropRate = JsonToDouble.fromJson(json.displayDropRate);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAdditiveChanceWeightPerDraw) {
      result.additiveChanceWeightPerDraw = JsonToDouble.toJson(this._additiveChanceWeightPerDraw);
    }
    if (this._hasClearCumulativeDrawCount) {
      result.clearCumulativeDrawCount = JsonToBoolean.toJson(this._clearCumulativeDrawCount);
    }
    if (this._hasText) {
      result.text = JsonToString.toJson(this._text);
    }
    if (this._hasDisplayDropRate) {
      result.displayDropRate = JsonToDouble.toJson(this._displayDropRate);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get additiveChanceWeightPerDraw() {
    return this._hasAdditiveChanceWeightPerDraw ? this._additiveChanceWeightPerDraw : JsonToDouble.default;
  }
  get hasAdditiveChanceWeightPerDraw() {
    return this._hasAdditiveChanceWeightPerDraw;
  }
  setAdditiveChanceWeightPerDraw(path, value) {
    return {type: 'SET', path: path.concat(['additiveChanceWeightPerDraw']), value};
  }
  deleteAdditiveChanceWeightPerDraw(path) {
    return {type: 'DELETE', path: path.concat(['additiveChanceWeightPerDraw'])};
  }
  /**
   * @returns {boolean}
   */
  get clearCumulativeDrawCount() {
    return this._hasClearCumulativeDrawCount ? this._clearCumulativeDrawCount : JsonToBoolean.default;
  }
  get hasClearCumulativeDrawCount() {
    return this._hasClearCumulativeDrawCount;
  }
  setClearCumulativeDrawCount(path, value) {
    return {type: 'SET', path: path.concat(['clearCumulativeDrawCount']), value};
  }
  deleteClearCumulativeDrawCount(path) {
    return {type: 'DELETE', path: path.concat(['clearCumulativeDrawCount'])};
  }
  /**
   * @returns {string}
   */
  get text() {
    return this._hasText ? this._text : JsonToString.default;
  }
  get hasText() {
    return this._hasText;
  }
  setText(path, value) {
    return {type: 'SET', path: path.concat(['text']), value};
  }
  deleteText(path) {
    return {type: 'DELETE', path: path.concat(['text'])};
  }
  /**
   * @returns {number}
   */
  get displayDropRate() {
    return this._hasDisplayDropRate ? this._displayDropRate : JsonToDouble.default;
  }
  get hasDisplayDropRate() {
    return this._hasDisplayDropRate;
  }
  setDisplayDropRate(path, value) {
    return {type: 'SET', path: path.concat(['displayDropRate']), value};
  }
  deleteDisplayDropRate(path) {
    return {type: 'DELETE', path: path.concat(['displayDropRate'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_PromotedItem(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new Chest_PromotedItem(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "additiveChanceWeightPerDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_PromotedItem(this);
              copy._hasAdditiveChanceWeightPerDraw = true;
              copy._additiveChanceWeightPerDraw = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAdditiveChanceWeightPerDraw) {
                return this;
              }
              const copy = new Chest_PromotedItem(this);
              copy._hasAdditiveChanceWeightPerDraw = false;
              copy._additiveChanceWeightPerDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "clearCumulativeDrawCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_PromotedItem(this);
              copy._hasClearCumulativeDrawCount = true;
              copy._clearCumulativeDrawCount = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClearCumulativeDrawCount) {
                return this;
              }
              const copy = new Chest_PromotedItem(this);
              copy._hasClearCumulativeDrawCount = false;
              copy._clearCumulativeDrawCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "text": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_PromotedItem(this);
              copy._hasText = true;
              copy._text = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasText) {
                return this;
              }
              const copy = new Chest_PromotedItem(this);
              copy._hasText = false;
              copy._text = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayDropRate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest_PromotedItem(this);
              copy._hasDisplayDropRate = true;
              copy._displayDropRate = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayDropRate) {
                return this;
              }
              const copy = new Chest_PromotedItem(this);
              copy._hasDisplayDropRate = false;
              copy._displayDropRate = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Chest_PromotedItem} other
   * @returns {Chest_PromotedItem}
   */
  merge(other) {
    const copy = new Chest_PromotedItem(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAdditiveChanceWeightPerDraw) {
      copy._hasAdditiveChanceWeightPerDraw = true;
      copy._additiveChanceWeightPerDraw = other._additiveChanceWeightPerDraw;
    }
    if (other._hasClearCumulativeDrawCount) {
      copy._hasClearCumulativeDrawCount = true;
      copy._clearCumulativeDrawCount = other._clearCumulativeDrawCount;
    }
    if (other._hasText) {
      copy._hasText = true;
      copy._text = other._text;
    }
    if (other._hasDisplayDropRate) {
      copy._hasDisplayDropRate = true;
      copy._displayDropRate = other._displayDropRate;
    }
    return copy;
  }
}
Chest_PromotedItem.default = new Chest_PromotedItem();
class Chest_PromotedItem_Builder {
  constructor(value) {
    this._value = new Chest_PromotedItem(value);
  }
  build() {
    return new Chest_PromotedItem(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAdditiveChanceWeightPerDraw(value) {
    this._value._hasAdditiveChanceWeightPerDraw = true;
    this._value._additiveChanceWeightPerDraw = value;
    return this;
  }
  deleteAdditiveChanceWeightPerDraw() {
    this._value._hasAdditiveChanceWeightPerDraw = false;
    this._value._additiveChanceWeightPerDraw = null;
    return this;
  }
  setClearCumulativeDrawCount(value) {
    this._value._hasClearCumulativeDrawCount = true;
    this._value._clearCumulativeDrawCount = value;
    return this;
  }
  deleteClearCumulativeDrawCount() {
    this._value._hasClearCumulativeDrawCount = false;
    this._value._clearCumulativeDrawCount = null;
    return this;
  }
  setText(value) {
    this._value._hasText = true;
    this._value._text = value;
    return this;
  }
  deleteText() {
    this._value._hasText = false;
    this._value._text = null;
    return this;
  }
  setDisplayDropRate(value) {
    this._value._hasDisplayDropRate = true;
    this._value._displayDropRate = value;
    return this;
  }
  deleteDisplayDropRate() {
    this._value._hasDisplayDropRate = false;
    this._value._displayDropRate = null;
    return this;
  }
}
Chest_PromotedItem.Builder = Chest_PromotedItem_Builder;
class Chest_PromotedItem_WithParent {
  /**
   * @param {Chest_PromotedItem} value
   * @param {Chest_PromotedItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Chest_PromotedItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAdditiveChanceWeightPerDraw() {
    if (this._cachedHasAdditiveChanceWeightPerDraw === undefined) {
      if (this._value.hasAdditiveChanceWeightPerDraw) {
        this._cachedHasAdditiveChanceWeightPerDraw = true;
      } else {
        this._cachedHasAdditiveChanceWeightPerDraw = this._parent ? this._parent.hasAdditiveChanceWeightPerDraw : false;
      }
    }
    return this._cachedHasAdditiveChanceWeightPerDraw;
  }
  get additiveChanceWeightPerDraw() {
    if (this._cachedAdditiveChanceWeightPerDraw === undefined) {
      if (this._value.hasAdditiveChanceWeightPerDraw) {
        this._cachedAdditiveChanceWeightPerDraw = this._value.additiveChanceWeightPerDraw;
      } else {
        this._cachedAdditiveChanceWeightPerDraw = this._parent ? this._parent.additiveChanceWeightPerDraw : this._value.additiveChanceWeightPerDraw;
      }
    }
    return this._cachedAdditiveChanceWeightPerDraw;
  }
  get hasClearCumulativeDrawCount() {
    if (this._cachedHasClearCumulativeDrawCount === undefined) {
      if (this._value.hasClearCumulativeDrawCount) {
        this._cachedHasClearCumulativeDrawCount = true;
      } else {
        this._cachedHasClearCumulativeDrawCount = this._parent ? this._parent.hasClearCumulativeDrawCount : false;
      }
    }
    return this._cachedHasClearCumulativeDrawCount;
  }
  get clearCumulativeDrawCount() {
    if (this._cachedClearCumulativeDrawCount === undefined) {
      if (this._value.hasClearCumulativeDrawCount) {
        this._cachedClearCumulativeDrawCount = this._value.clearCumulativeDrawCount;
      } else {
        this._cachedClearCumulativeDrawCount = this._parent ? this._parent.clearCumulativeDrawCount : this._value.clearCumulativeDrawCount;
      }
    }
    return this._cachedClearCumulativeDrawCount;
  }
  get hasText() {
    if (this._cachedHasText === undefined) {
      if (this._value.hasText) {
        this._cachedHasText = true;
      } else {
        this._cachedHasText = this._parent ? this._parent.hasText : false;
      }
    }
    return this._cachedHasText;
  }
  get text() {
    if (this._cachedText === undefined) {
      if (this._value.hasText) {
        this._cachedText = this._value.text;
      } else {
        this._cachedText = this._parent ? this._parent.text : this._value.text;
      }
    }
    return this._cachedText;
  }
  get hasDisplayDropRate() {
    if (this._cachedHasDisplayDropRate === undefined) {
      if (this._value.hasDisplayDropRate) {
        this._cachedHasDisplayDropRate = true;
      } else {
        this._cachedHasDisplayDropRate = this._parent ? this._parent.hasDisplayDropRate : false;
      }
    }
    return this._cachedHasDisplayDropRate;
  }
  get displayDropRate() {
    if (this._cachedDisplayDropRate === undefined) {
      if (this._value.hasDisplayDropRate) {
        this._cachedDisplayDropRate = this._value.displayDropRate;
      } else {
        this._cachedDisplayDropRate = this._parent ? this._parent.displayDropRate : this._value.displayDropRate;
      }
    }
    return this._cachedDisplayDropRate;
  }
  update(current, parent) {
    const result = new Chest_PromotedItem_WithParent(current, parent);
    return result;
  }
}
Chest_PromotedItem_WithParent.default = new Chest_PromotedItem_WithParent(Chest_PromotedItem.default, null);
Chest_PromotedItem.WithParent = Chest_PromotedItem_WithParent;
class Chest_PromotedItem_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get additiveChanceWeightPerDraw() {
    if (!this._additiveChanceWeightPerDraw) {
      this._additiveChanceWeightPerDraw = {
        name: "additiveChanceWeightPerDraw",
        Name: "AdditiveChanceWeightPerDraw",
        number: 2,
        protoType: 1,
        protoName: "additive_chance_weight_per_draw",
        type: JsonToDouble,
        options: {
          comments: "this value will be added to the original chance weight of the target item when promotion calculation begins",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._additiveChanceWeightPerDraw;
  }
  get clearCumulativeDrawCount() {
    if (!this._clearCumulativeDrawCount) {
      this._clearCumulativeDrawCount = {
        name: "clearCumulativeDrawCount",
        Name: "ClearCumulativeDrawCount",
        number: 3,
        protoType: 8,
        protoName: "clear_cumulative_draw_count",
        type: JsonToBoolean,
        options: {
          comments: "if ture, cummulatice draw count will be cleared when players get the item",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clearCumulativeDrawCount;
  }
  get text() {
    if (!this._text) {
      this._text = {
        name: "text",
        Name: "Text",
        number: 4,
        protoType: 9,
        protoName: "text",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._text;
  }
  get displayDropRate() {
    if (!this._displayDropRate) {
      this._displayDropRate = {
        name: "displayDropRate",
        Name: "DisplayDropRate",
        number: 5,
        protoType: 1,
        protoName: "display_drop_rate",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayDropRate;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.additiveChanceWeightPerDraw,
        this.clearCumulativeDrawCount,
        this.text,
        this.displayDropRate,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAdditiveChanceWeightPerDraw",
        Name: "DummyOneofForAdditiveChanceWeightPerDraw",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForClearCumulativeDrawCount",
        Name: "DummyOneofForClearCumulativeDrawCount",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForText",
        Name: "DummyOneofForText",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayDropRate",
        Name: "DummyOneofForDisplayDropRate",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
Chest_PromotedItem.descriptor = new Chest_PromotedItem_Descriptor();
export class Chest {
  get descriptor() {
    return Chest.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._slots = [];
    this._hasCurrencyKey = false;
    this._currencyKey = null;
    this._hasCurrencyAmount = false;
    this._currencyAmount = null;
    this._hasAlternativeCurrencyKey = false;
    this._alternativeCurrencyKey = null;
    this._hasAlternativeCurrencyAmount = false;
    this._alternativeCurrencyAmount = null;
    this._hasTier = false;
    this._tier = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasDisplayNameOverwriteInChestView = false;
    this._displayNameOverwriteInChestView = null;
    this._hasEnableTenDraws = false;
    this._enableTenDraws = null;
    this._hasCurrencyAmountTenDraws = false;
    this._currencyAmountTenDraws = null;
    this._hasAlternativeCurrencyAmountTenDraws = false;
    this._alternativeCurrencyAmountTenDraws = null;
    this._hasEnableTenDrawsGuaranteeReward = false;
    this._enableTenDrawsGuaranteeReward = null;
    this._tenDrawGuaranteeRewards = [];
    this._hasEnablePromotedItems = false;
    this._enablePromotedItems = null;
    this._hasXThDrawsPromotionBegin = false;
    this._xThDrawsPromotionBegin = null;
    this._hasExpectedDrawCountOfPromotedItems = false;
    this._expectedDrawCountOfPromotedItems = null;
    this._promotedItems = [];
    this._hasChestRewardTypeInfo = false;
    this._chestRewardTypeInfo = null;
    this._hasChestRewardTypeInfo2 = false;
    this._chestRewardTypeInfo2 = null;
    this._displayMessages = [];
    this._hasDisplayPossibleRewardsDropPercentage = false;
    this._displayPossibleRewardsDropPercentage = null;
    this._hasDropRateInfo = false;
    this._dropRateInfo = null;
    this._hasChestCloseImage = false;
    this._chestCloseImage = null;
    this._hasChestOpenImage = false;
    this._chestOpenImage = null;
    this._hasChestPrefab = false;
    this._chestPrefab = null;
    this._hasShowcasePrefab = false;
    this._showcasePrefab = null;
  }
  isEmpty() {
    if (this._slots.length > 0) return false;
    if (this._hasCurrencyKey) return false;
    if (this._hasCurrencyAmount) return false;
    if (this._hasAlternativeCurrencyKey) return false;
    if (this._hasAlternativeCurrencyAmount) return false;
    if (this._hasTier) return false;
    if (this._hasDisplayName) return false;
    if (this._hasDisplayNameOverwriteInChestView) return false;
    if (this._hasEnableTenDraws) return false;
    if (this._hasCurrencyAmountTenDraws) return false;
    if (this._hasAlternativeCurrencyAmountTenDraws) return false;
    if (this._hasEnableTenDrawsGuaranteeReward) return false;
    if (this._tenDrawGuaranteeRewards.length > 0) return false;
    if (this._hasEnablePromotedItems) return false;
    if (this._hasXThDrawsPromotionBegin) return false;
    if (this._hasExpectedDrawCountOfPromotedItems) return false;
    if (this._promotedItems.length > 0) return false;
    if (this._hasChestRewardTypeInfo) return false;
    if (this._hasChestRewardTypeInfo2) return false;
    if (this._displayMessages.length > 0) return false;
    if (this._hasDisplayPossibleRewardsDropPercentage) return false;
    if (this._hasDropRateInfo) return false;
    if (this._hasChestCloseImage) return false;
    if (this._hasChestOpenImage) return false;
    if (this._hasChestPrefab) return false;
    if (this._hasShowcasePrefab) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Chest) {
      return value;
    }
    return Chest.fromJson(value);
  }
  static fromJson(json) {
    const result = new Chest();
    result._slots = JsonToList(json.slots, ChestSlot);
    if (json.currencyKey != null) {
      result._hasCurrencyKey = true;
      result._currencyKey = JsonToString.fromJson(json.currencyKey);
    }
    if (json.currencyAmount != null) {
      result._hasCurrencyAmount = true;
      result._currencyAmount = JsonToInt32.fromJson(json.currencyAmount);
    }
    if (json.alternativeCurrencyKey != null) {
      result._hasAlternativeCurrencyKey = true;
      result._alternativeCurrencyKey = JsonToString.fromJson(json.alternativeCurrencyKey);
    }
    if (json.alternativeCurrencyAmount != null) {
      result._hasAlternativeCurrencyAmount = true;
      result._alternativeCurrencyAmount = JsonToInt32.fromJson(json.alternativeCurrencyAmount);
    }
    if (json.tier != null) {
      result._hasTier = true;
      result._tier = JsonToInt32.fromJson(json.tier);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.displayNameOverwriteInChestView != null) {
      result._hasDisplayNameOverwriteInChestView = true;
      result._displayNameOverwriteInChestView = JsonToString.fromJson(json.displayNameOverwriteInChestView);
    }
    if (json.enableTenDraws != null) {
      result._hasEnableTenDraws = true;
      result._enableTenDraws = JsonToBoolean.fromJson(json.enableTenDraws);
    }
    if (json.currencyAmountTenDraws != null) {
      result._hasCurrencyAmountTenDraws = true;
      result._currencyAmountTenDraws = JsonToInt32.fromJson(json.currencyAmountTenDraws);
    }
    if (json.alternativeCurrencyAmountTenDraws != null) {
      result._hasAlternativeCurrencyAmountTenDraws = true;
      result._alternativeCurrencyAmountTenDraws = JsonToInt32.fromJson(json.alternativeCurrencyAmountTenDraws);
    }
    if (json.enableTenDrawsGuaranteeReward != null) {
      result._hasEnableTenDrawsGuaranteeReward = true;
      result._enableTenDrawsGuaranteeReward = JsonToBoolean.fromJson(json.enableTenDrawsGuaranteeReward);
    }
    result._tenDrawGuaranteeRewards = JsonToList(json.tenDrawGuaranteeRewards, Chest_TenDrawGuaranteeReward);
    if (json.enablePromotedItems != null) {
      result._hasEnablePromotedItems = true;
      result._enablePromotedItems = JsonToBoolean.fromJson(json.enablePromotedItems);
    }
    if (json.xThDrawsPromotionBegin != null) {
      result._hasXThDrawsPromotionBegin = true;
      result._xThDrawsPromotionBegin = JsonToInt32.fromJson(json.xThDrawsPromotionBegin);
    }
    if (json.expectedDrawCountOfPromotedItems != null) {
      result._hasExpectedDrawCountOfPromotedItems = true;
      result._expectedDrawCountOfPromotedItems = JsonToInt32.fromJson(json.expectedDrawCountOfPromotedItems);
    }
    result._promotedItems = JsonToList(json.promotedItems, Chest_PromotedItem);
    if (json.chestRewardTypeInfo != null) {
      result._hasChestRewardTypeInfo = true;
      result._chestRewardTypeInfo = JsonToString.fromJson(json.chestRewardTypeInfo);
    }
    if (json.chestRewardTypeInfo2 != null) {
      result._hasChestRewardTypeInfo2 = true;
      result._chestRewardTypeInfo2 = JsonToString.fromJson(json.chestRewardTypeInfo2);
    }
    result._displayMessages = JsonToList(json.displayMessages, Chest_DisplayMessage);
    if (json.displayPossibleRewardsDropPercentage != null) {
      result._hasDisplayPossibleRewardsDropPercentage = true;
      result._displayPossibleRewardsDropPercentage = JsonToDouble.fromJson(json.displayPossibleRewardsDropPercentage);
    }
    if (json.dropRateInfo != null) {
      result._hasDropRateInfo = true;
      result._dropRateInfo = JsonToString.fromJson(json.dropRateInfo);
    }
    if (json.chestCloseImage != null) {
      result._hasChestCloseImage = true;
      result._chestCloseImage = JsonToString.fromJson(json.chestCloseImage);
    }
    if (json.chestOpenImage != null) {
      result._hasChestOpenImage = true;
      result._chestOpenImage = JsonToString.fromJson(json.chestOpenImage);
    }
    if (json.chestPrefab != null) {
      result._hasChestPrefab = true;
      result._chestPrefab = JsonToString.fromJson(json.chestPrefab);
    }
    if (json.showcasePrefab != null) {
      result._hasShowcasePrefab = true;
      result._showcasePrefab = JsonToString.fromJson(json.showcasePrefab);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._slots.length > 0) {
      result.slots = ArrayToJson(this._slots, ChestSlot);
    }
    if (this._hasCurrencyKey) {
      result.currencyKey = JsonToString.toJson(this._currencyKey);
    }
    if (this._hasCurrencyAmount) {
      result.currencyAmount = JsonToInt32.toJson(this._currencyAmount);
    }
    if (this._hasAlternativeCurrencyKey) {
      result.alternativeCurrencyKey = JsonToString.toJson(this._alternativeCurrencyKey);
    }
    if (this._hasAlternativeCurrencyAmount) {
      result.alternativeCurrencyAmount = JsonToInt32.toJson(this._alternativeCurrencyAmount);
    }
    if (this._hasTier) {
      result.tier = JsonToInt32.toJson(this._tier);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasDisplayNameOverwriteInChestView) {
      result.displayNameOverwriteInChestView = JsonToString.toJson(this._displayNameOverwriteInChestView);
    }
    if (this._hasEnableTenDraws) {
      result.enableTenDraws = JsonToBoolean.toJson(this._enableTenDraws);
    }
    if (this._hasCurrencyAmountTenDraws) {
      result.currencyAmountTenDraws = JsonToInt32.toJson(this._currencyAmountTenDraws);
    }
    if (this._hasAlternativeCurrencyAmountTenDraws) {
      result.alternativeCurrencyAmountTenDraws = JsonToInt32.toJson(this._alternativeCurrencyAmountTenDraws);
    }
    if (this._hasEnableTenDrawsGuaranteeReward) {
      result.enableTenDrawsGuaranteeReward = JsonToBoolean.toJson(this._enableTenDrawsGuaranteeReward);
    }
    if (this._tenDrawGuaranteeRewards.length > 0) {
      result.tenDrawGuaranteeRewards = ArrayToJson(this._tenDrawGuaranteeRewards, Chest_TenDrawGuaranteeReward);
    }
    if (this._hasEnablePromotedItems) {
      result.enablePromotedItems = JsonToBoolean.toJson(this._enablePromotedItems);
    }
    if (this._hasXThDrawsPromotionBegin) {
      result.xThDrawsPromotionBegin = JsonToInt32.toJson(this._xThDrawsPromotionBegin);
    }
    if (this._hasExpectedDrawCountOfPromotedItems) {
      result.expectedDrawCountOfPromotedItems = JsonToInt32.toJson(this._expectedDrawCountOfPromotedItems);
    }
    if (this._promotedItems.length > 0) {
      result.promotedItems = ArrayToJson(this._promotedItems, Chest_PromotedItem);
    }
    if (this._hasChestRewardTypeInfo) {
      result.chestRewardTypeInfo = JsonToString.toJson(this._chestRewardTypeInfo);
    }
    if (this._hasChestRewardTypeInfo2) {
      result.chestRewardTypeInfo2 = JsonToString.toJson(this._chestRewardTypeInfo2);
    }
    if (this._displayMessages.length > 0) {
      result.displayMessages = ArrayToJson(this._displayMessages, Chest_DisplayMessage);
    }
    if (this._hasDisplayPossibleRewardsDropPercentage) {
      result.displayPossibleRewardsDropPercentage = JsonToDouble.toJson(this._displayPossibleRewardsDropPercentage);
    }
    if (this._hasDropRateInfo) {
      result.dropRateInfo = JsonToString.toJson(this._dropRateInfo);
    }
    if (this._hasChestCloseImage) {
      result.chestCloseImage = JsonToString.toJson(this._chestCloseImage);
    }
    if (this._hasChestOpenImage) {
      result.chestOpenImage = JsonToString.toJson(this._chestOpenImage);
    }
    if (this._hasChestPrefab) {
      result.chestPrefab = JsonToString.toJson(this._chestPrefab);
    }
    if (this._hasShowcasePrefab) {
      result.showcasePrefab = JsonToString.toJson(this._showcasePrefab);
    }
    return result;
  }
  /**
   * @returns {ChestSlot[]}
   */
  get slots() {
    return this._slots;
  }
  addSlots(path, value) {
    return {type: 'ADD', path: path.concat(['slots']), value: value.toJson()};
  }
  setSlots(path, value) {
    return {type: 'SET', path: path.concat(['slots']), value: ArrayToJson(value, ChestSlot)};
  }
  setSlotsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slots', key]), value: value.toJson()};
  }
  deleteSlots(path) {
    return {type: 'DELETE', path: path.concat(['slots'])};
  }
  deleteSlotsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slots', key])};
  }
  /**
   * @returns {string}
   */
  get currencyKey() {
    return this._hasCurrencyKey ? this._currencyKey : JsonToString.default;
  }
  get hasCurrencyKey() {
    return this._hasCurrencyKey;
  }
  setCurrencyKey(path, value) {
    return {type: 'SET', path: path.concat(['currencyKey']), value};
  }
  deleteCurrencyKey(path) {
    return {type: 'DELETE', path: path.concat(['currencyKey'])};
  }
  /**
   * @returns {number}
   */
  get currencyAmount() {
    return this._hasCurrencyAmount ? this._currencyAmount : JsonToInt32.default;
  }
  get hasCurrencyAmount() {
    return this._hasCurrencyAmount;
  }
  setCurrencyAmount(path, value) {
    return {type: 'SET', path: path.concat(['currencyAmount']), value};
  }
  deleteCurrencyAmount(path) {
    return {type: 'DELETE', path: path.concat(['currencyAmount'])};
  }
  /**
   * @returns {string}
   */
  get alternativeCurrencyKey() {
    return this._hasAlternativeCurrencyKey ? this._alternativeCurrencyKey : JsonToString.default;
  }
  get hasAlternativeCurrencyKey() {
    return this._hasAlternativeCurrencyKey;
  }
  setAlternativeCurrencyKey(path, value) {
    return {type: 'SET', path: path.concat(['alternativeCurrencyKey']), value};
  }
  deleteAlternativeCurrencyKey(path) {
    return {type: 'DELETE', path: path.concat(['alternativeCurrencyKey'])};
  }
  /**
   * @returns {number}
   */
  get alternativeCurrencyAmount() {
    return this._hasAlternativeCurrencyAmount ? this._alternativeCurrencyAmount : JsonToInt32.default;
  }
  get hasAlternativeCurrencyAmount() {
    return this._hasAlternativeCurrencyAmount;
  }
  setAlternativeCurrencyAmount(path, value) {
    return {type: 'SET', path: path.concat(['alternativeCurrencyAmount']), value};
  }
  deleteAlternativeCurrencyAmount(path) {
    return {type: 'DELETE', path: path.concat(['alternativeCurrencyAmount'])};
  }
  /**
   * @returns {number}
   */
  get tier() {
    return this._hasTier ? this._tier : JsonToInt32.default;
  }
  get hasTier() {
    return this._hasTier;
  }
  setTier(path, value) {
    return {type: 'SET', path: path.concat(['tier']), value};
  }
  deleteTier(path) {
    return {type: 'DELETE', path: path.concat(['tier'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string}
   */
  get displayNameOverwriteInChestView() {
    return this._hasDisplayNameOverwriteInChestView ? this._displayNameOverwriteInChestView : JsonToString.default;
  }
  get hasDisplayNameOverwriteInChestView() {
    return this._hasDisplayNameOverwriteInChestView;
  }
  setDisplayNameOverwriteInChestView(path, value) {
    return {type: 'SET', path: path.concat(['displayNameOverwriteInChestView']), value};
  }
  deleteDisplayNameOverwriteInChestView(path) {
    return {type: 'DELETE', path: path.concat(['displayNameOverwriteInChestView'])};
  }
  /**
   * @returns {boolean}
   */
  get enableTenDraws() {
    return this._hasEnableTenDraws ? this._enableTenDraws : JsonToBoolean.default;
  }
  get hasEnableTenDraws() {
    return this._hasEnableTenDraws;
  }
  setEnableTenDraws(path, value) {
    return {type: 'SET', path: path.concat(['enableTenDraws']), value};
  }
  deleteEnableTenDraws(path) {
    return {type: 'DELETE', path: path.concat(['enableTenDraws'])};
  }
  /**
   * @returns {number}
   */
  get currencyAmountTenDraws() {
    return this._hasCurrencyAmountTenDraws ? this._currencyAmountTenDraws : JsonToInt32.default;
  }
  get hasCurrencyAmountTenDraws() {
    return this._hasCurrencyAmountTenDraws;
  }
  setCurrencyAmountTenDraws(path, value) {
    return {type: 'SET', path: path.concat(['currencyAmountTenDraws']), value};
  }
  deleteCurrencyAmountTenDraws(path) {
    return {type: 'DELETE', path: path.concat(['currencyAmountTenDraws'])};
  }
  /**
   * @returns {number}
   */
  get alternativeCurrencyAmountTenDraws() {
    return this._hasAlternativeCurrencyAmountTenDraws ? this._alternativeCurrencyAmountTenDraws : JsonToInt32.default;
  }
  get hasAlternativeCurrencyAmountTenDraws() {
    return this._hasAlternativeCurrencyAmountTenDraws;
  }
  setAlternativeCurrencyAmountTenDraws(path, value) {
    return {type: 'SET', path: path.concat(['alternativeCurrencyAmountTenDraws']), value};
  }
  deleteAlternativeCurrencyAmountTenDraws(path) {
    return {type: 'DELETE', path: path.concat(['alternativeCurrencyAmountTenDraws'])};
  }
  /**
   * @returns {boolean}
   */
  get enableTenDrawsGuaranteeReward() {
    return this._hasEnableTenDrawsGuaranteeReward ? this._enableTenDrawsGuaranteeReward : JsonToBoolean.default;
  }
  get hasEnableTenDrawsGuaranteeReward() {
    return this._hasEnableTenDrawsGuaranteeReward;
  }
  setEnableTenDrawsGuaranteeReward(path, value) {
    return {type: 'SET', path: path.concat(['enableTenDrawsGuaranteeReward']), value};
  }
  deleteEnableTenDrawsGuaranteeReward(path) {
    return {type: 'DELETE', path: path.concat(['enableTenDrawsGuaranteeReward'])};
  }
  /**
   * @returns {Chest_TenDrawGuaranteeReward[]}
   */
  get tenDrawGuaranteeRewards() {
    return this._tenDrawGuaranteeRewards;
  }
  addTenDrawGuaranteeRewards(path, value) {
    return {type: 'ADD', path: path.concat(['tenDrawGuaranteeRewards']), value: value.toJson()};
  }
  setTenDrawGuaranteeRewards(path, value) {
    return {type: 'SET', path: path.concat(['tenDrawGuaranteeRewards']), value: ArrayToJson(value, Chest_TenDrawGuaranteeReward)};
  }
  setTenDrawGuaranteeRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tenDrawGuaranteeRewards', key]), value: value.toJson()};
  }
  deleteTenDrawGuaranteeRewards(path) {
    return {type: 'DELETE', path: path.concat(['tenDrawGuaranteeRewards'])};
  }
  deleteTenDrawGuaranteeRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tenDrawGuaranteeRewards', key])};
  }
  /**
   * @returns {boolean}
   */
  get enablePromotedItems() {
    return this._hasEnablePromotedItems ? this._enablePromotedItems : JsonToBoolean.default;
  }
  get hasEnablePromotedItems() {
    return this._hasEnablePromotedItems;
  }
  setEnablePromotedItems(path, value) {
    return {type: 'SET', path: path.concat(['enablePromotedItems']), value};
  }
  deleteEnablePromotedItems(path) {
    return {type: 'DELETE', path: path.concat(['enablePromotedItems'])};
  }
  /**
   * @returns {number}
   */
  get xThDrawsPromotionBegin() {
    return this._hasXThDrawsPromotionBegin ? this._xThDrawsPromotionBegin : JsonToInt32.default;
  }
  get hasXThDrawsPromotionBegin() {
    return this._hasXThDrawsPromotionBegin;
  }
  setXThDrawsPromotionBegin(path, value) {
    return {type: 'SET', path: path.concat(['xThDrawsPromotionBegin']), value};
  }
  deleteXThDrawsPromotionBegin(path) {
    return {type: 'DELETE', path: path.concat(['xThDrawsPromotionBegin'])};
  }
  /**
   * @returns {number}
   */
  get expectedDrawCountOfPromotedItems() {
    return this._hasExpectedDrawCountOfPromotedItems ? this._expectedDrawCountOfPromotedItems : JsonToInt32.default;
  }
  get hasExpectedDrawCountOfPromotedItems() {
    return this._hasExpectedDrawCountOfPromotedItems;
  }
  setExpectedDrawCountOfPromotedItems(path, value) {
    return {type: 'SET', path: path.concat(['expectedDrawCountOfPromotedItems']), value};
  }
  deleteExpectedDrawCountOfPromotedItems(path) {
    return {type: 'DELETE', path: path.concat(['expectedDrawCountOfPromotedItems'])};
  }
  /**
   * @returns {Chest_PromotedItem[]}
   */
  get promotedItems() {
    return this._promotedItems;
  }
  addPromotedItems(path, value) {
    return {type: 'ADD', path: path.concat(['promotedItems']), value: value.toJson()};
  }
  setPromotedItems(path, value) {
    return {type: 'SET', path: path.concat(['promotedItems']), value: ArrayToJson(value, Chest_PromotedItem)};
  }
  setPromotedItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['promotedItems', key]), value: value.toJson()};
  }
  deletePromotedItems(path) {
    return {type: 'DELETE', path: path.concat(['promotedItems'])};
  }
  deletePromotedItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['promotedItems', key])};
  }
  /**
   * @returns {string}
   */
  get chestRewardTypeInfo() {
    return this._hasChestRewardTypeInfo ? this._chestRewardTypeInfo : JsonToString.default;
  }
  get hasChestRewardTypeInfo() {
    return this._hasChestRewardTypeInfo;
  }
  setChestRewardTypeInfo(path, value) {
    return {type: 'SET', path: path.concat(['chestRewardTypeInfo']), value};
  }
  deleteChestRewardTypeInfo(path) {
    return {type: 'DELETE', path: path.concat(['chestRewardTypeInfo'])};
  }
  /**
   * @returns {string}
   */
  get chestRewardTypeInfo2() {
    return this._hasChestRewardTypeInfo2 ? this._chestRewardTypeInfo2 : JsonToString.default;
  }
  get hasChestRewardTypeInfo2() {
    return this._hasChestRewardTypeInfo2;
  }
  setChestRewardTypeInfo2(path, value) {
    return {type: 'SET', path: path.concat(['chestRewardTypeInfo2']), value};
  }
  deleteChestRewardTypeInfo2(path) {
    return {type: 'DELETE', path: path.concat(['chestRewardTypeInfo2'])};
  }
  /**
   * @returns {Chest_DisplayMessage[]}
   */
  get displayMessages() {
    return this._displayMessages;
  }
  addDisplayMessages(path, value) {
    return {type: 'ADD', path: path.concat(['displayMessages']), value: value.toJson()};
  }
  setDisplayMessages(path, value) {
    return {type: 'SET', path: path.concat(['displayMessages']), value: ArrayToJson(value, Chest_DisplayMessage)};
  }
  setDisplayMessagesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['displayMessages', key]), value: value.toJson()};
  }
  deleteDisplayMessages(path) {
    return {type: 'DELETE', path: path.concat(['displayMessages'])};
  }
  deleteDisplayMessagesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['displayMessages', key])};
  }
  /**
   * @returns {number}
   */
  get displayPossibleRewardsDropPercentage() {
    return this._hasDisplayPossibleRewardsDropPercentage ? this._displayPossibleRewardsDropPercentage : JsonToDouble.default;
  }
  get hasDisplayPossibleRewardsDropPercentage() {
    return this._hasDisplayPossibleRewardsDropPercentage;
  }
  setDisplayPossibleRewardsDropPercentage(path, value) {
    return {type: 'SET', path: path.concat(['displayPossibleRewardsDropPercentage']), value};
  }
  deleteDisplayPossibleRewardsDropPercentage(path) {
    return {type: 'DELETE', path: path.concat(['displayPossibleRewardsDropPercentage'])};
  }
  /**
   * @returns {string}
   */
  get dropRateInfo() {
    return this._hasDropRateInfo ? this._dropRateInfo : JsonToString.default;
  }
  get hasDropRateInfo() {
    return this._hasDropRateInfo;
  }
  setDropRateInfo(path, value) {
    return {type: 'SET', path: path.concat(['dropRateInfo']), value};
  }
  deleteDropRateInfo(path) {
    return {type: 'DELETE', path: path.concat(['dropRateInfo'])};
  }
  /**
   * @returns {string}
   */
  get chestCloseImage() {
    return this._hasChestCloseImage ? this._chestCloseImage : JsonToString.default;
  }
  get hasChestCloseImage() {
    return this._hasChestCloseImage;
  }
  setChestCloseImage(path, value) {
    return {type: 'SET', path: path.concat(['chestCloseImage']), value};
  }
  deleteChestCloseImage(path) {
    return {type: 'DELETE', path: path.concat(['chestCloseImage'])};
  }
  /**
   * @returns {string}
   */
  get chestOpenImage() {
    return this._hasChestOpenImage ? this._chestOpenImage : JsonToString.default;
  }
  get hasChestOpenImage() {
    return this._hasChestOpenImage;
  }
  setChestOpenImage(path, value) {
    return {type: 'SET', path: path.concat(['chestOpenImage']), value};
  }
  deleteChestOpenImage(path) {
    return {type: 'DELETE', path: path.concat(['chestOpenImage'])};
  }
  /**
   * @returns {string}
   */
  get chestPrefab() {
    return this._hasChestPrefab ? this._chestPrefab : JsonToString.default;
  }
  get hasChestPrefab() {
    return this._hasChestPrefab;
  }
  setChestPrefab(path, value) {
    return {type: 'SET', path: path.concat(['chestPrefab']), value};
  }
  deleteChestPrefab(path) {
    return {type: 'DELETE', path: path.concat(['chestPrefab'])};
  }
  /**
   * @returns {string}
   */
  get showcasePrefab() {
    return this._hasShowcasePrefab ? this._showcasePrefab : JsonToString.default;
  }
  get hasShowcasePrefab() {
    return this._hasShowcasePrefab;
  }
  setShowcasePrefab(path, value) {
    return {type: 'SET', path: path.concat(['showcasePrefab']), value};
  }
  deleteShowcasePrefab(path) {
    return {type: 'DELETE', path: path.concat(['showcasePrefab'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "slots": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._slots = [];        for (let i of value) {
                copy._slots.push(ChestSlot.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Chest(this);
              copy._slots = copy._slots.concat([ChestSlot.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slots.length === 0) {
                return this;
              }
              const copy = new Chest(this);
              copy._slots = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._slots = copy._slots.slice();
              copy._slots[path[1]] = ChestSlot.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Chest(this);
              copy._slots = copy._slots.slice(0, path[1]).concat(copy._slots.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          const oldValue = this._slots[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Chest(this);
          copy._slots = copy._slots.slice();
          copy._slots[key] = newValue;
          return copy;
        }
      }
      case "currencyKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasCurrencyKey = true;
              copy._currencyKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrencyKey) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasCurrencyKey = false;
              copy._currencyKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currencyAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasCurrencyAmount = true;
              copy._currencyAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrencyAmount) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasCurrencyAmount = false;
              copy._currencyAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "alternativeCurrencyKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasAlternativeCurrencyKey = true;
              copy._alternativeCurrencyKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAlternativeCurrencyKey) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasAlternativeCurrencyKey = false;
              copy._alternativeCurrencyKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "alternativeCurrencyAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasAlternativeCurrencyAmount = true;
              copy._alternativeCurrencyAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAlternativeCurrencyAmount) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasAlternativeCurrencyAmount = false;
              copy._alternativeCurrencyAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasTier = true;
              copy._tier = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTier) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasTier = false;
              copy._tier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayNameOverwriteInChestView": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasDisplayNameOverwriteInChestView = true;
              copy._displayNameOverwriteInChestView = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayNameOverwriteInChestView) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasDisplayNameOverwriteInChestView = false;
              copy._displayNameOverwriteInChestView = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "enableTenDraws": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasEnableTenDraws = true;
              copy._enableTenDraws = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnableTenDraws) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasEnableTenDraws = false;
              copy._enableTenDraws = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currencyAmountTenDraws": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasCurrencyAmountTenDraws = true;
              copy._currencyAmountTenDraws = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrencyAmountTenDraws) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasCurrencyAmountTenDraws = false;
              copy._currencyAmountTenDraws = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "alternativeCurrencyAmountTenDraws": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasAlternativeCurrencyAmountTenDraws = true;
              copy._alternativeCurrencyAmountTenDraws = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAlternativeCurrencyAmountTenDraws) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasAlternativeCurrencyAmountTenDraws = false;
              copy._alternativeCurrencyAmountTenDraws = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "enableTenDrawsGuaranteeReward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasEnableTenDrawsGuaranteeReward = true;
              copy._enableTenDrawsGuaranteeReward = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnableTenDrawsGuaranteeReward) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasEnableTenDrawsGuaranteeReward = false;
              copy._enableTenDrawsGuaranteeReward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tenDrawGuaranteeRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._tenDrawGuaranteeRewards = [];        for (let i of value) {
                copy._tenDrawGuaranteeRewards.push(Chest_TenDrawGuaranteeReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Chest(this);
              copy._tenDrawGuaranteeRewards = copy._tenDrawGuaranteeRewards.concat([Chest_TenDrawGuaranteeReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tenDrawGuaranteeRewards.length === 0) {
                return this;
              }
              const copy = new Chest(this);
              copy._tenDrawGuaranteeRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tenDrawGuaranteeRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._tenDrawGuaranteeRewards = copy._tenDrawGuaranteeRewards.slice();
              copy._tenDrawGuaranteeRewards[path[1]] = Chest_TenDrawGuaranteeReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Chest(this);
              copy._tenDrawGuaranteeRewards = copy._tenDrawGuaranteeRewards.slice(0, path[1]).concat(copy._tenDrawGuaranteeRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tenDrawGuaranteeRewards.length) {
            return this;
          }
          const oldValue = this._tenDrawGuaranteeRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Chest(this);
          copy._tenDrawGuaranteeRewards = copy._tenDrawGuaranteeRewards.slice();
          copy._tenDrawGuaranteeRewards[key] = newValue;
          return copy;
        }
      }
      case "enablePromotedItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasEnablePromotedItems = true;
              copy._enablePromotedItems = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnablePromotedItems) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasEnablePromotedItems = false;
              copy._enablePromotedItems = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "xThDrawsPromotionBegin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasXThDrawsPromotionBegin = true;
              copy._xThDrawsPromotionBegin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXThDrawsPromotionBegin) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasXThDrawsPromotionBegin = false;
              copy._xThDrawsPromotionBegin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expectedDrawCountOfPromotedItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasExpectedDrawCountOfPromotedItems = true;
              copy._expectedDrawCountOfPromotedItems = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExpectedDrawCountOfPromotedItems) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasExpectedDrawCountOfPromotedItems = false;
              copy._expectedDrawCountOfPromotedItems = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "promotedItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._promotedItems = [];        for (let i of value) {
                copy._promotedItems.push(Chest_PromotedItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Chest(this);
              copy._promotedItems = copy._promotedItems.concat([Chest_PromotedItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._promotedItems.length === 0) {
                return this;
              }
              const copy = new Chest(this);
              copy._promotedItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._promotedItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._promotedItems = copy._promotedItems.slice();
              copy._promotedItems[path[1]] = Chest_PromotedItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Chest(this);
              copy._promotedItems = copy._promotedItems.slice(0, path[1]).concat(copy._promotedItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._promotedItems.length) {
            return this;
          }
          const oldValue = this._promotedItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Chest(this);
          copy._promotedItems = copy._promotedItems.slice();
          copy._promotedItems[key] = newValue;
          return copy;
        }
      }
      case "chestRewardTypeInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasChestRewardTypeInfo = true;
              copy._chestRewardTypeInfo = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestRewardTypeInfo) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasChestRewardTypeInfo = false;
              copy._chestRewardTypeInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestRewardTypeInfo2": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasChestRewardTypeInfo2 = true;
              copy._chestRewardTypeInfo2 = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestRewardTypeInfo2) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasChestRewardTypeInfo2 = false;
              copy._chestRewardTypeInfo2 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayMessages": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._displayMessages = [];        for (let i of value) {
                copy._displayMessages.push(Chest_DisplayMessage.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Chest(this);
              copy._displayMessages = copy._displayMessages.concat([Chest_DisplayMessage.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._displayMessages.length === 0) {
                return this;
              }
              const copy = new Chest(this);
              copy._displayMessages = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._displayMessages.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._displayMessages = copy._displayMessages.slice();
              copy._displayMessages[path[1]] = Chest_DisplayMessage.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Chest(this);
              copy._displayMessages = copy._displayMessages.slice(0, path[1]).concat(copy._displayMessages.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._displayMessages.length) {
            return this;
          }
          const oldValue = this._displayMessages[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Chest(this);
          copy._displayMessages = copy._displayMessages.slice();
          copy._displayMessages[key] = newValue;
          return copy;
        }
      }
      case "displayPossibleRewardsDropPercentage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasDisplayPossibleRewardsDropPercentage = true;
              copy._displayPossibleRewardsDropPercentage = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayPossibleRewardsDropPercentage) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasDisplayPossibleRewardsDropPercentage = false;
              copy._displayPossibleRewardsDropPercentage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dropRateInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasDropRateInfo = true;
              copy._dropRateInfo = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDropRateInfo) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasDropRateInfo = false;
              copy._dropRateInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestCloseImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasChestCloseImage = true;
              copy._chestCloseImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestCloseImage) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasChestCloseImage = false;
              copy._chestCloseImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestOpenImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasChestOpenImage = true;
              copy._chestOpenImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestOpenImage) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasChestOpenImage = false;
              copy._chestOpenImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestPrefab": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasChestPrefab = true;
              copy._chestPrefab = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestPrefab) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasChestPrefab = false;
              copy._chestPrefab = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showcasePrefab": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Chest(this);
              copy._hasShowcasePrefab = true;
              copy._showcasePrefab = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowcasePrefab) {
                return this;
              }
              const copy = new Chest(this);
              copy._hasShowcasePrefab = false;
              copy._showcasePrefab = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Chest} other
   * @returns {Chest}
   */
  merge(other) {
    const copy = new Chest(this);
    copy._slots = this._slots.concat(other._slots);
    if (other._hasCurrencyKey) {
      copy._hasCurrencyKey = true;
      copy._currencyKey = other._currencyKey;
    }
    if (other._hasCurrencyAmount) {
      copy._hasCurrencyAmount = true;
      copy._currencyAmount = other._currencyAmount;
    }
    if (other._hasAlternativeCurrencyKey) {
      copy._hasAlternativeCurrencyKey = true;
      copy._alternativeCurrencyKey = other._alternativeCurrencyKey;
    }
    if (other._hasAlternativeCurrencyAmount) {
      copy._hasAlternativeCurrencyAmount = true;
      copy._alternativeCurrencyAmount = other._alternativeCurrencyAmount;
    }
    if (other._hasTier) {
      copy._hasTier = true;
      copy._tier = other._tier;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasDisplayNameOverwriteInChestView) {
      copy._hasDisplayNameOverwriteInChestView = true;
      copy._displayNameOverwriteInChestView = other._displayNameOverwriteInChestView;
    }
    if (other._hasEnableTenDraws) {
      copy._hasEnableTenDraws = true;
      copy._enableTenDraws = other._enableTenDraws;
    }
    if (other._hasCurrencyAmountTenDraws) {
      copy._hasCurrencyAmountTenDraws = true;
      copy._currencyAmountTenDraws = other._currencyAmountTenDraws;
    }
    if (other._hasAlternativeCurrencyAmountTenDraws) {
      copy._hasAlternativeCurrencyAmountTenDraws = true;
      copy._alternativeCurrencyAmountTenDraws = other._alternativeCurrencyAmountTenDraws;
    }
    if (other._hasEnableTenDrawsGuaranteeReward) {
      copy._hasEnableTenDrawsGuaranteeReward = true;
      copy._enableTenDrawsGuaranteeReward = other._enableTenDrawsGuaranteeReward;
    }
    copy._tenDrawGuaranteeRewards = this._tenDrawGuaranteeRewards.concat(other._tenDrawGuaranteeRewards);
    if (other._hasEnablePromotedItems) {
      copy._hasEnablePromotedItems = true;
      copy._enablePromotedItems = other._enablePromotedItems;
    }
    if (other._hasXThDrawsPromotionBegin) {
      copy._hasXThDrawsPromotionBegin = true;
      copy._xThDrawsPromotionBegin = other._xThDrawsPromotionBegin;
    }
    if (other._hasExpectedDrawCountOfPromotedItems) {
      copy._hasExpectedDrawCountOfPromotedItems = true;
      copy._expectedDrawCountOfPromotedItems = other._expectedDrawCountOfPromotedItems;
    }
    copy._promotedItems = this._promotedItems.concat(other._promotedItems);
    if (other._hasChestRewardTypeInfo) {
      copy._hasChestRewardTypeInfo = true;
      copy._chestRewardTypeInfo = other._chestRewardTypeInfo;
    }
    if (other._hasChestRewardTypeInfo2) {
      copy._hasChestRewardTypeInfo2 = true;
      copy._chestRewardTypeInfo2 = other._chestRewardTypeInfo2;
    }
    copy._displayMessages = this._displayMessages.concat(other._displayMessages);
    if (other._hasDisplayPossibleRewardsDropPercentage) {
      copy._hasDisplayPossibleRewardsDropPercentage = true;
      copy._displayPossibleRewardsDropPercentage = other._displayPossibleRewardsDropPercentage;
    }
    if (other._hasDropRateInfo) {
      copy._hasDropRateInfo = true;
      copy._dropRateInfo = other._dropRateInfo;
    }
    if (other._hasChestCloseImage) {
      copy._hasChestCloseImage = true;
      copy._chestCloseImage = other._chestCloseImage;
    }
    if (other._hasChestOpenImage) {
      copy._hasChestOpenImage = true;
      copy._chestOpenImage = other._chestOpenImage;
    }
    if (other._hasChestPrefab) {
      copy._hasChestPrefab = true;
      copy._chestPrefab = other._chestPrefab;
    }
    if (other._hasShowcasePrefab) {
      copy._hasShowcasePrefab = true;
      copy._showcasePrefab = other._showcasePrefab;
    }
    return copy;
  }
}
Chest.default = new Chest();
Chest.DisplayMessage = Chest_DisplayMessage;
Chest.GuaranteeRewardCandidate = Chest_GuaranteeRewardCandidate;
Chest.GuaranteeRewardSlot = Chest_GuaranteeRewardSlot;
Chest.TenDrawGuaranteeReward = Chest_TenDrawGuaranteeReward;
Chest.PromotedItem = Chest_PromotedItem;
class Chest_Builder {
  constructor(value) {
    this._value = new Chest(value);
  }
  build() {
    return new Chest(this._value);
  }
  addAllSlots(values) {
    this._value._slots = this._value._slots.concat(values);
    return this;
  }
  addSlots(value) {
    this._value._slots = this._value._slots.concat([value]);
    return this;
  }
  setSlots(index, value) {
    this._value._slots = this._value._slots.concat();
    this._value._slots[index] = value;
    return this;
  }
  clearSlots() {
    this._value._slots = [];
    return this;
  }
  setCurrencyKey(value) {
    this._value._hasCurrencyKey = true;
    this._value._currencyKey = value;
    return this;
  }
  deleteCurrencyKey() {
    this._value._hasCurrencyKey = false;
    this._value._currencyKey = null;
    return this;
  }
  setCurrencyAmount(value) {
    this._value._hasCurrencyAmount = true;
    this._value._currencyAmount = value;
    return this;
  }
  deleteCurrencyAmount() {
    this._value._hasCurrencyAmount = false;
    this._value._currencyAmount = null;
    return this;
  }
  setAlternativeCurrencyKey(value) {
    this._value._hasAlternativeCurrencyKey = true;
    this._value._alternativeCurrencyKey = value;
    return this;
  }
  deleteAlternativeCurrencyKey() {
    this._value._hasAlternativeCurrencyKey = false;
    this._value._alternativeCurrencyKey = null;
    return this;
  }
  setAlternativeCurrencyAmount(value) {
    this._value._hasAlternativeCurrencyAmount = true;
    this._value._alternativeCurrencyAmount = value;
    return this;
  }
  deleteAlternativeCurrencyAmount() {
    this._value._hasAlternativeCurrencyAmount = false;
    this._value._alternativeCurrencyAmount = null;
    return this;
  }
  setTier(value) {
    this._value._hasTier = true;
    this._value._tier = value;
    return this;
  }
  deleteTier() {
    this._value._hasTier = false;
    this._value._tier = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setDisplayNameOverwriteInChestView(value) {
    this._value._hasDisplayNameOverwriteInChestView = true;
    this._value._displayNameOverwriteInChestView = value;
    return this;
  }
  deleteDisplayNameOverwriteInChestView() {
    this._value._hasDisplayNameOverwriteInChestView = false;
    this._value._displayNameOverwriteInChestView = null;
    return this;
  }
  setEnableTenDraws(value) {
    this._value._hasEnableTenDraws = true;
    this._value._enableTenDraws = value;
    return this;
  }
  deleteEnableTenDraws() {
    this._value._hasEnableTenDraws = false;
    this._value._enableTenDraws = null;
    return this;
  }
  setCurrencyAmountTenDraws(value) {
    this._value._hasCurrencyAmountTenDraws = true;
    this._value._currencyAmountTenDraws = value;
    return this;
  }
  deleteCurrencyAmountTenDraws() {
    this._value._hasCurrencyAmountTenDraws = false;
    this._value._currencyAmountTenDraws = null;
    return this;
  }
  setAlternativeCurrencyAmountTenDraws(value) {
    this._value._hasAlternativeCurrencyAmountTenDraws = true;
    this._value._alternativeCurrencyAmountTenDraws = value;
    return this;
  }
  deleteAlternativeCurrencyAmountTenDraws() {
    this._value._hasAlternativeCurrencyAmountTenDraws = false;
    this._value._alternativeCurrencyAmountTenDraws = null;
    return this;
  }
  setEnableTenDrawsGuaranteeReward(value) {
    this._value._hasEnableTenDrawsGuaranteeReward = true;
    this._value._enableTenDrawsGuaranteeReward = value;
    return this;
  }
  deleteEnableTenDrawsGuaranteeReward() {
    this._value._hasEnableTenDrawsGuaranteeReward = false;
    this._value._enableTenDrawsGuaranteeReward = null;
    return this;
  }
  addAllTenDrawGuaranteeRewards(values) {
    this._value._tenDrawGuaranteeRewards = this._value._tenDrawGuaranteeRewards.concat(values);
    return this;
  }
  addTenDrawGuaranteeRewards(value) {
    this._value._tenDrawGuaranteeRewards = this._value._tenDrawGuaranteeRewards.concat([value]);
    return this;
  }
  setTenDrawGuaranteeRewards(index, value) {
    this._value._tenDrawGuaranteeRewards = this._value._tenDrawGuaranteeRewards.concat();
    this._value._tenDrawGuaranteeRewards[index] = value;
    return this;
  }
  clearTenDrawGuaranteeRewards() {
    this._value._tenDrawGuaranteeRewards = [];
    return this;
  }
  setEnablePromotedItems(value) {
    this._value._hasEnablePromotedItems = true;
    this._value._enablePromotedItems = value;
    return this;
  }
  deleteEnablePromotedItems() {
    this._value._hasEnablePromotedItems = false;
    this._value._enablePromotedItems = null;
    return this;
  }
  setXThDrawsPromotionBegin(value) {
    this._value._hasXThDrawsPromotionBegin = true;
    this._value._xThDrawsPromotionBegin = value;
    return this;
  }
  deleteXThDrawsPromotionBegin() {
    this._value._hasXThDrawsPromotionBegin = false;
    this._value._xThDrawsPromotionBegin = null;
    return this;
  }
  setExpectedDrawCountOfPromotedItems(value) {
    this._value._hasExpectedDrawCountOfPromotedItems = true;
    this._value._expectedDrawCountOfPromotedItems = value;
    return this;
  }
  deleteExpectedDrawCountOfPromotedItems() {
    this._value._hasExpectedDrawCountOfPromotedItems = false;
    this._value._expectedDrawCountOfPromotedItems = null;
    return this;
  }
  addAllPromotedItems(values) {
    this._value._promotedItems = this._value._promotedItems.concat(values);
    return this;
  }
  addPromotedItems(value) {
    this._value._promotedItems = this._value._promotedItems.concat([value]);
    return this;
  }
  setPromotedItems(index, value) {
    this._value._promotedItems = this._value._promotedItems.concat();
    this._value._promotedItems[index] = value;
    return this;
  }
  clearPromotedItems() {
    this._value._promotedItems = [];
    return this;
  }
  setChestRewardTypeInfo(value) {
    this._value._hasChestRewardTypeInfo = true;
    this._value._chestRewardTypeInfo = value;
    return this;
  }
  deleteChestRewardTypeInfo() {
    this._value._hasChestRewardTypeInfo = false;
    this._value._chestRewardTypeInfo = null;
    return this;
  }
  setChestRewardTypeInfo2(value) {
    this._value._hasChestRewardTypeInfo2 = true;
    this._value._chestRewardTypeInfo2 = value;
    return this;
  }
  deleteChestRewardTypeInfo2() {
    this._value._hasChestRewardTypeInfo2 = false;
    this._value._chestRewardTypeInfo2 = null;
    return this;
  }
  addAllDisplayMessages(values) {
    this._value._displayMessages = this._value._displayMessages.concat(values);
    return this;
  }
  addDisplayMessages(value) {
    this._value._displayMessages = this._value._displayMessages.concat([value]);
    return this;
  }
  setDisplayMessages(index, value) {
    this._value._displayMessages = this._value._displayMessages.concat();
    this._value._displayMessages[index] = value;
    return this;
  }
  clearDisplayMessages() {
    this._value._displayMessages = [];
    return this;
  }
  setDisplayPossibleRewardsDropPercentage(value) {
    this._value._hasDisplayPossibleRewardsDropPercentage = true;
    this._value._displayPossibleRewardsDropPercentage = value;
    return this;
  }
  deleteDisplayPossibleRewardsDropPercentage() {
    this._value._hasDisplayPossibleRewardsDropPercentage = false;
    this._value._displayPossibleRewardsDropPercentage = null;
    return this;
  }
  setDropRateInfo(value) {
    this._value._hasDropRateInfo = true;
    this._value._dropRateInfo = value;
    return this;
  }
  deleteDropRateInfo() {
    this._value._hasDropRateInfo = false;
    this._value._dropRateInfo = null;
    return this;
  }
  setChestCloseImage(value) {
    this._value._hasChestCloseImage = true;
    this._value._chestCloseImage = value;
    return this;
  }
  deleteChestCloseImage() {
    this._value._hasChestCloseImage = false;
    this._value._chestCloseImage = null;
    return this;
  }
  setChestOpenImage(value) {
    this._value._hasChestOpenImage = true;
    this._value._chestOpenImage = value;
    return this;
  }
  deleteChestOpenImage() {
    this._value._hasChestOpenImage = false;
    this._value._chestOpenImage = null;
    return this;
  }
  setChestPrefab(value) {
    this._value._hasChestPrefab = true;
    this._value._chestPrefab = value;
    return this;
  }
  deleteChestPrefab() {
    this._value._hasChestPrefab = false;
    this._value._chestPrefab = null;
    return this;
  }
  setShowcasePrefab(value) {
    this._value._hasShowcasePrefab = true;
    this._value._showcasePrefab = value;
    return this;
  }
  deleteShowcasePrefab() {
    this._value._hasShowcasePrefab = false;
    this._value._showcasePrefab = null;
    return this;
  }
}
Chest.Builder = Chest_Builder;
class Chest_WithParent {
  /**
   * @param {Chest} value
   * @param {Chest_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Chest.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSlots() {
    if (!this._selfSlots) {
      this._selfSlots = [];
      for (let i of this._value.slots) {
        this._selfSlots.push(new ChestSlot.WithParent(i, null));
      }
    }
    return this._selfSlots;
  }
  get inherentSlots() {
    if (!this._inherentSlots) {
      this._inherentSlots = this._parent ? this._parent.slots : [];
    }
    return this._inherentSlots;
  }
  get slots() {
    if (!this._allSlots) {
      this._allSlots = this._parent ? this._parent.slots.concat(this.selfSlots) : this.selfSlots;
    }
    return this._allSlots;
  }
  get hasCurrencyKey() {
    if (this._cachedHasCurrencyKey === undefined) {
      if (this._value.hasCurrencyKey) {
        this._cachedHasCurrencyKey = true;
      } else {
        this._cachedHasCurrencyKey = this._parent ? this._parent.hasCurrencyKey : false;
      }
    }
    return this._cachedHasCurrencyKey;
  }
  get currencyKey() {
    if (this._cachedCurrencyKey === undefined) {
      if (this._value.hasCurrencyKey) {
        this._cachedCurrencyKey = this._value.currencyKey;
      } else {
        this._cachedCurrencyKey = this._parent ? this._parent.currencyKey : this._value.currencyKey;
      }
    }
    return this._cachedCurrencyKey;
  }
  get hasCurrencyAmount() {
    if (this._cachedHasCurrencyAmount === undefined) {
      if (this._value.hasCurrencyAmount) {
        this._cachedHasCurrencyAmount = true;
      } else {
        this._cachedHasCurrencyAmount = this._parent ? this._parent.hasCurrencyAmount : false;
      }
    }
    return this._cachedHasCurrencyAmount;
  }
  get currencyAmount() {
    if (this._cachedCurrencyAmount === undefined) {
      if (this._value.hasCurrencyAmount) {
        this._cachedCurrencyAmount = this._value.currencyAmount;
      } else {
        this._cachedCurrencyAmount = this._parent ? this._parent.currencyAmount : this._value.currencyAmount;
      }
    }
    return this._cachedCurrencyAmount;
  }
  get hasAlternativeCurrencyKey() {
    if (this._cachedHasAlternativeCurrencyKey === undefined) {
      if (this._value.hasAlternativeCurrencyKey) {
        this._cachedHasAlternativeCurrencyKey = true;
      } else {
        this._cachedHasAlternativeCurrencyKey = this._parent ? this._parent.hasAlternativeCurrencyKey : false;
      }
    }
    return this._cachedHasAlternativeCurrencyKey;
  }
  get alternativeCurrencyKey() {
    if (this._cachedAlternativeCurrencyKey === undefined) {
      if (this._value.hasAlternativeCurrencyKey) {
        this._cachedAlternativeCurrencyKey = this._value.alternativeCurrencyKey;
      } else {
        this._cachedAlternativeCurrencyKey = this._parent ? this._parent.alternativeCurrencyKey : this._value.alternativeCurrencyKey;
      }
    }
    return this._cachedAlternativeCurrencyKey;
  }
  get hasAlternativeCurrencyAmount() {
    if (this._cachedHasAlternativeCurrencyAmount === undefined) {
      if (this._value.hasAlternativeCurrencyAmount) {
        this._cachedHasAlternativeCurrencyAmount = true;
      } else {
        this._cachedHasAlternativeCurrencyAmount = this._parent ? this._parent.hasAlternativeCurrencyAmount : false;
      }
    }
    return this._cachedHasAlternativeCurrencyAmount;
  }
  get alternativeCurrencyAmount() {
    if (this._cachedAlternativeCurrencyAmount === undefined) {
      if (this._value.hasAlternativeCurrencyAmount) {
        this._cachedAlternativeCurrencyAmount = this._value.alternativeCurrencyAmount;
      } else {
        this._cachedAlternativeCurrencyAmount = this._parent ? this._parent.alternativeCurrencyAmount : this._value.alternativeCurrencyAmount;
      }
    }
    return this._cachedAlternativeCurrencyAmount;
  }
  get hasTier() {
    if (this._cachedHasTier === undefined) {
      if (this._value.hasTier) {
        this._cachedHasTier = true;
      } else {
        this._cachedHasTier = this._parent ? this._parent.hasTier : false;
      }
    }
    return this._cachedHasTier;
  }
  get tier() {
    if (this._cachedTier === undefined) {
      if (this._value.hasTier) {
        this._cachedTier = this._value.tier;
      } else {
        this._cachedTier = this._parent ? this._parent.tier : this._value.tier;
      }
    }
    return this._cachedTier;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasDisplayNameOverwriteInChestView() {
    if (this._cachedHasDisplayNameOverwriteInChestView === undefined) {
      if (this._value.hasDisplayNameOverwriteInChestView) {
        this._cachedHasDisplayNameOverwriteInChestView = true;
      } else {
        this._cachedHasDisplayNameOverwriteInChestView = this._parent ? this._parent.hasDisplayNameOverwriteInChestView : false;
      }
    }
    return this._cachedHasDisplayNameOverwriteInChestView;
  }
  get displayNameOverwriteInChestView() {
    if (this._cachedDisplayNameOverwriteInChestView === undefined) {
      if (this._value.hasDisplayNameOverwriteInChestView) {
        this._cachedDisplayNameOverwriteInChestView = this._value.displayNameOverwriteInChestView;
      } else {
        this._cachedDisplayNameOverwriteInChestView = this._parent ? this._parent.displayNameOverwriteInChestView : this._value.displayNameOverwriteInChestView;
      }
    }
    return this._cachedDisplayNameOverwriteInChestView;
  }
  get hasEnableTenDraws() {
    if (this._cachedHasEnableTenDraws === undefined) {
      if (this._value.hasEnableTenDraws) {
        this._cachedHasEnableTenDraws = true;
      } else {
        this._cachedHasEnableTenDraws = this._parent ? this._parent.hasEnableTenDraws : false;
      }
    }
    return this._cachedHasEnableTenDraws;
  }
  get enableTenDraws() {
    if (this._cachedEnableTenDraws === undefined) {
      if (this._value.hasEnableTenDraws) {
        this._cachedEnableTenDraws = this._value.enableTenDraws;
      } else {
        this._cachedEnableTenDraws = this._parent ? this._parent.enableTenDraws : this._value.enableTenDraws;
      }
    }
    return this._cachedEnableTenDraws;
  }
  get hasCurrencyAmountTenDraws() {
    if (this._cachedHasCurrencyAmountTenDraws === undefined) {
      if (this._value.hasCurrencyAmountTenDraws) {
        this._cachedHasCurrencyAmountTenDraws = true;
      } else {
        this._cachedHasCurrencyAmountTenDraws = this._parent ? this._parent.hasCurrencyAmountTenDraws : false;
      }
    }
    return this._cachedHasCurrencyAmountTenDraws;
  }
  get currencyAmountTenDraws() {
    if (this._cachedCurrencyAmountTenDraws === undefined) {
      if (this._value.hasCurrencyAmountTenDraws) {
        this._cachedCurrencyAmountTenDraws = this._value.currencyAmountTenDraws;
      } else {
        this._cachedCurrencyAmountTenDraws = this._parent ? this._parent.currencyAmountTenDraws : this._value.currencyAmountTenDraws;
      }
    }
    return this._cachedCurrencyAmountTenDraws;
  }
  get hasAlternativeCurrencyAmountTenDraws() {
    if (this._cachedHasAlternativeCurrencyAmountTenDraws === undefined) {
      if (this._value.hasAlternativeCurrencyAmountTenDraws) {
        this._cachedHasAlternativeCurrencyAmountTenDraws = true;
      } else {
        this._cachedHasAlternativeCurrencyAmountTenDraws = this._parent ? this._parent.hasAlternativeCurrencyAmountTenDraws : false;
      }
    }
    return this._cachedHasAlternativeCurrencyAmountTenDraws;
  }
  get alternativeCurrencyAmountTenDraws() {
    if (this._cachedAlternativeCurrencyAmountTenDraws === undefined) {
      if (this._value.hasAlternativeCurrencyAmountTenDraws) {
        this._cachedAlternativeCurrencyAmountTenDraws = this._value.alternativeCurrencyAmountTenDraws;
      } else {
        this._cachedAlternativeCurrencyAmountTenDraws = this._parent ? this._parent.alternativeCurrencyAmountTenDraws : this._value.alternativeCurrencyAmountTenDraws;
      }
    }
    return this._cachedAlternativeCurrencyAmountTenDraws;
  }
  get hasEnableTenDrawsGuaranteeReward() {
    if (this._cachedHasEnableTenDrawsGuaranteeReward === undefined) {
      if (this._value.hasEnableTenDrawsGuaranteeReward) {
        this._cachedHasEnableTenDrawsGuaranteeReward = true;
      } else {
        this._cachedHasEnableTenDrawsGuaranteeReward = this._parent ? this._parent.hasEnableTenDrawsGuaranteeReward : false;
      }
    }
    return this._cachedHasEnableTenDrawsGuaranteeReward;
  }
  get enableTenDrawsGuaranteeReward() {
    if (this._cachedEnableTenDrawsGuaranteeReward === undefined) {
      if (this._value.hasEnableTenDrawsGuaranteeReward) {
        this._cachedEnableTenDrawsGuaranteeReward = this._value.enableTenDrawsGuaranteeReward;
      } else {
        this._cachedEnableTenDrawsGuaranteeReward = this._parent ? this._parent.enableTenDrawsGuaranteeReward : this._value.enableTenDrawsGuaranteeReward;
      }
    }
    return this._cachedEnableTenDrawsGuaranteeReward;
  }
  get selfTenDrawGuaranteeRewards() {
    if (!this._selfTenDrawGuaranteeRewards) {
      this._selfTenDrawGuaranteeRewards = [];
      for (let i of this._value.tenDrawGuaranteeRewards) {
        this._selfTenDrawGuaranteeRewards.push(new Chest_TenDrawGuaranteeReward.WithParent(i, null));
      }
    }
    return this._selfTenDrawGuaranteeRewards;
  }
  get inherentTenDrawGuaranteeRewards() {
    if (!this._inherentTenDrawGuaranteeRewards) {
      this._inherentTenDrawGuaranteeRewards = this._parent ? this._parent.tenDrawGuaranteeRewards : [];
    }
    return this._inherentTenDrawGuaranteeRewards;
  }
  get tenDrawGuaranteeRewards() {
    if (!this._allTenDrawGuaranteeRewards) {
      this._allTenDrawGuaranteeRewards = this._parent ? this._parent.tenDrawGuaranteeRewards.concat(this.selfTenDrawGuaranteeRewards) : this.selfTenDrawGuaranteeRewards;
    }
    return this._allTenDrawGuaranteeRewards;
  }
  get hasEnablePromotedItems() {
    if (this._cachedHasEnablePromotedItems === undefined) {
      if (this._value.hasEnablePromotedItems) {
        this._cachedHasEnablePromotedItems = true;
      } else {
        this._cachedHasEnablePromotedItems = this._parent ? this._parent.hasEnablePromotedItems : false;
      }
    }
    return this._cachedHasEnablePromotedItems;
  }
  get enablePromotedItems() {
    if (this._cachedEnablePromotedItems === undefined) {
      if (this._value.hasEnablePromotedItems) {
        this._cachedEnablePromotedItems = this._value.enablePromotedItems;
      } else {
        this._cachedEnablePromotedItems = this._parent ? this._parent.enablePromotedItems : this._value.enablePromotedItems;
      }
    }
    return this._cachedEnablePromotedItems;
  }
  get hasXThDrawsPromotionBegin() {
    if (this._cachedHasXThDrawsPromotionBegin === undefined) {
      if (this._value.hasXThDrawsPromotionBegin) {
        this._cachedHasXThDrawsPromotionBegin = true;
      } else {
        this._cachedHasXThDrawsPromotionBegin = this._parent ? this._parent.hasXThDrawsPromotionBegin : false;
      }
    }
    return this._cachedHasXThDrawsPromotionBegin;
  }
  get xThDrawsPromotionBegin() {
    if (this._cachedXThDrawsPromotionBegin === undefined) {
      if (this._value.hasXThDrawsPromotionBegin) {
        this._cachedXThDrawsPromotionBegin = this._value.xThDrawsPromotionBegin;
      } else {
        this._cachedXThDrawsPromotionBegin = this._parent ? this._parent.xThDrawsPromotionBegin : this._value.xThDrawsPromotionBegin;
      }
    }
    return this._cachedXThDrawsPromotionBegin;
  }
  get hasExpectedDrawCountOfPromotedItems() {
    if (this._cachedHasExpectedDrawCountOfPromotedItems === undefined) {
      if (this._value.hasExpectedDrawCountOfPromotedItems) {
        this._cachedHasExpectedDrawCountOfPromotedItems = true;
      } else {
        this._cachedHasExpectedDrawCountOfPromotedItems = this._parent ? this._parent.hasExpectedDrawCountOfPromotedItems : false;
      }
    }
    return this._cachedHasExpectedDrawCountOfPromotedItems;
  }
  get expectedDrawCountOfPromotedItems() {
    if (this._cachedExpectedDrawCountOfPromotedItems === undefined) {
      if (this._value.hasExpectedDrawCountOfPromotedItems) {
        this._cachedExpectedDrawCountOfPromotedItems = this._value.expectedDrawCountOfPromotedItems;
      } else {
        this._cachedExpectedDrawCountOfPromotedItems = this._parent ? this._parent.expectedDrawCountOfPromotedItems : this._value.expectedDrawCountOfPromotedItems;
      }
    }
    return this._cachedExpectedDrawCountOfPromotedItems;
  }
  get selfPromotedItems() {
    if (!this._selfPromotedItems) {
      this._selfPromotedItems = [];
      for (let i of this._value.promotedItems) {
        this._selfPromotedItems.push(new Chest_PromotedItem.WithParent(i, null));
      }
    }
    return this._selfPromotedItems;
  }
  get inherentPromotedItems() {
    if (!this._inherentPromotedItems) {
      this._inherentPromotedItems = this._parent ? this._parent.promotedItems : [];
    }
    return this._inherentPromotedItems;
  }
  get promotedItems() {
    if (!this._allPromotedItems) {
      this._allPromotedItems = this._parent ? this._parent.promotedItems.concat(this.selfPromotedItems) : this.selfPromotedItems;
    }
    return this._allPromotedItems;
  }
  get hasChestRewardTypeInfo() {
    if (this._cachedHasChestRewardTypeInfo === undefined) {
      if (this._value.hasChestRewardTypeInfo) {
        this._cachedHasChestRewardTypeInfo = true;
      } else {
        this._cachedHasChestRewardTypeInfo = this._parent ? this._parent.hasChestRewardTypeInfo : false;
      }
    }
    return this._cachedHasChestRewardTypeInfo;
  }
  get chestRewardTypeInfo() {
    if (this._cachedChestRewardTypeInfo === undefined) {
      if (this._value.hasChestRewardTypeInfo) {
        this._cachedChestRewardTypeInfo = this._value.chestRewardTypeInfo;
      } else {
        this._cachedChestRewardTypeInfo = this._parent ? this._parent.chestRewardTypeInfo : this._value.chestRewardTypeInfo;
      }
    }
    return this._cachedChestRewardTypeInfo;
  }
  get hasChestRewardTypeInfo2() {
    if (this._cachedHasChestRewardTypeInfo2 === undefined) {
      if (this._value.hasChestRewardTypeInfo2) {
        this._cachedHasChestRewardTypeInfo2 = true;
      } else {
        this._cachedHasChestRewardTypeInfo2 = this._parent ? this._parent.hasChestRewardTypeInfo2 : false;
      }
    }
    return this._cachedHasChestRewardTypeInfo2;
  }
  get chestRewardTypeInfo2() {
    if (this._cachedChestRewardTypeInfo2 === undefined) {
      if (this._value.hasChestRewardTypeInfo2) {
        this._cachedChestRewardTypeInfo2 = this._value.chestRewardTypeInfo2;
      } else {
        this._cachedChestRewardTypeInfo2 = this._parent ? this._parent.chestRewardTypeInfo2 : this._value.chestRewardTypeInfo2;
      }
    }
    return this._cachedChestRewardTypeInfo2;
  }
  get selfDisplayMessages() {
    if (!this._selfDisplayMessages) {
      this._selfDisplayMessages = [];
      for (let i of this._value.displayMessages) {
        this._selfDisplayMessages.push(new Chest_DisplayMessage.WithParent(i, null));
      }
    }
    return this._selfDisplayMessages;
  }
  get inherentDisplayMessages() {
    if (!this._inherentDisplayMessages) {
      this._inherentDisplayMessages = this._parent ? this._parent.displayMessages : [];
    }
    return this._inherentDisplayMessages;
  }
  get displayMessages() {
    if (!this._allDisplayMessages) {
      this._allDisplayMessages = this._parent ? this._parent.displayMessages.concat(this.selfDisplayMessages) : this.selfDisplayMessages;
    }
    return this._allDisplayMessages;
  }
  get hasDisplayPossibleRewardsDropPercentage() {
    if (this._cachedHasDisplayPossibleRewardsDropPercentage === undefined) {
      if (this._value.hasDisplayPossibleRewardsDropPercentage) {
        this._cachedHasDisplayPossibleRewardsDropPercentage = true;
      } else {
        this._cachedHasDisplayPossibleRewardsDropPercentage = this._parent ? this._parent.hasDisplayPossibleRewardsDropPercentage : false;
      }
    }
    return this._cachedHasDisplayPossibleRewardsDropPercentage;
  }
  get displayPossibleRewardsDropPercentage() {
    if (this._cachedDisplayPossibleRewardsDropPercentage === undefined) {
      if (this._value.hasDisplayPossibleRewardsDropPercentage) {
        this._cachedDisplayPossibleRewardsDropPercentage = this._value.displayPossibleRewardsDropPercentage;
      } else {
        this._cachedDisplayPossibleRewardsDropPercentage = this._parent ? this._parent.displayPossibleRewardsDropPercentage : this._value.displayPossibleRewardsDropPercentage;
      }
    }
    return this._cachedDisplayPossibleRewardsDropPercentage;
  }
  get hasDropRateInfo() {
    if (this._cachedHasDropRateInfo === undefined) {
      if (this._value.hasDropRateInfo) {
        this._cachedHasDropRateInfo = true;
      } else {
        this._cachedHasDropRateInfo = this._parent ? this._parent.hasDropRateInfo : false;
      }
    }
    return this._cachedHasDropRateInfo;
  }
  get dropRateInfo() {
    if (this._cachedDropRateInfo === undefined) {
      if (this._value.hasDropRateInfo) {
        this._cachedDropRateInfo = this._value.dropRateInfo;
      } else {
        this._cachedDropRateInfo = this._parent ? this._parent.dropRateInfo : this._value.dropRateInfo;
      }
    }
    return this._cachedDropRateInfo;
  }
  get hasChestCloseImage() {
    if (this._cachedHasChestCloseImage === undefined) {
      if (this._value.hasChestCloseImage) {
        this._cachedHasChestCloseImage = true;
      } else {
        this._cachedHasChestCloseImage = this._parent ? this._parent.hasChestCloseImage : false;
      }
    }
    return this._cachedHasChestCloseImage;
  }
  get chestCloseImage() {
    if (this._cachedChestCloseImage === undefined) {
      if (this._value.hasChestCloseImage) {
        this._cachedChestCloseImage = this._value.chestCloseImage;
      } else {
        this._cachedChestCloseImage = this._parent ? this._parent.chestCloseImage : this._value.chestCloseImage;
      }
    }
    return this._cachedChestCloseImage;
  }
  get hasChestOpenImage() {
    if (this._cachedHasChestOpenImage === undefined) {
      if (this._value.hasChestOpenImage) {
        this._cachedHasChestOpenImage = true;
      } else {
        this._cachedHasChestOpenImage = this._parent ? this._parent.hasChestOpenImage : false;
      }
    }
    return this._cachedHasChestOpenImage;
  }
  get chestOpenImage() {
    if (this._cachedChestOpenImage === undefined) {
      if (this._value.hasChestOpenImage) {
        this._cachedChestOpenImage = this._value.chestOpenImage;
      } else {
        this._cachedChestOpenImage = this._parent ? this._parent.chestOpenImage : this._value.chestOpenImage;
      }
    }
    return this._cachedChestOpenImage;
  }
  get hasChestPrefab() {
    if (this._cachedHasChestPrefab === undefined) {
      if (this._value.hasChestPrefab) {
        this._cachedHasChestPrefab = true;
      } else {
        this._cachedHasChestPrefab = this._parent ? this._parent.hasChestPrefab : false;
      }
    }
    return this._cachedHasChestPrefab;
  }
  get chestPrefab() {
    if (this._cachedChestPrefab === undefined) {
      if (this._value.hasChestPrefab) {
        this._cachedChestPrefab = this._value.chestPrefab;
      } else {
        this._cachedChestPrefab = this._parent ? this._parent.chestPrefab : this._value.chestPrefab;
      }
    }
    return this._cachedChestPrefab;
  }
  get hasShowcasePrefab() {
    if (this._cachedHasShowcasePrefab === undefined) {
      if (this._value.hasShowcasePrefab) {
        this._cachedHasShowcasePrefab = true;
      } else {
        this._cachedHasShowcasePrefab = this._parent ? this._parent.hasShowcasePrefab : false;
      }
    }
    return this._cachedHasShowcasePrefab;
  }
  get showcasePrefab() {
    if (this._cachedShowcasePrefab === undefined) {
      if (this._value.hasShowcasePrefab) {
        this._cachedShowcasePrefab = this._value.showcasePrefab;
      } else {
        this._cachedShowcasePrefab = this._parent ? this._parent.showcasePrefab : this._value.showcasePrefab;
      }
    }
    return this._cachedShowcasePrefab;
  }
  update(current, parent) {
    const result = new Chest_WithParent(current, parent);
    if (this._selfSlots) {
      if (this._value.slots === current.slots) {
        result._selfSlots = this._selfSlots;
      } else {
        result._selfSlots = [];
        for (let i = 0; i < current.slots.length; i++) {
          const oldValue = this._value.slots[i];
          if (oldValue) {
            const oldCache = this._selfSlots[i];
            if (oldValue === current.slots[i]) {
              result._selfSlots[i] = oldCache;
            } else {
              result._selfSlots[i] = oldCache.update(current.slots[i], null);
            }
          } else {
            result._selfSlots[i] = new ChestSlot.WithParent(current.slots[i], null);
          }
        }
      }
    }
    if (this._selfTenDrawGuaranteeRewards) {
      if (this._value.tenDrawGuaranteeRewards === current.tenDrawGuaranteeRewards) {
        result._selfTenDrawGuaranteeRewards = this._selfTenDrawGuaranteeRewards;
      } else {
        result._selfTenDrawGuaranteeRewards = [];
        for (let i = 0; i < current.tenDrawGuaranteeRewards.length; i++) {
          const oldValue = this._value.tenDrawGuaranteeRewards[i];
          if (oldValue) {
            const oldCache = this._selfTenDrawGuaranteeRewards[i];
            if (oldValue === current.tenDrawGuaranteeRewards[i]) {
              result._selfTenDrawGuaranteeRewards[i] = oldCache;
            } else {
              result._selfTenDrawGuaranteeRewards[i] = oldCache.update(current.tenDrawGuaranteeRewards[i], null);
            }
          } else {
            result._selfTenDrawGuaranteeRewards[i] = new Chest_TenDrawGuaranteeReward.WithParent(current.tenDrawGuaranteeRewards[i], null);
          }
        }
      }
    }
    if (this._selfPromotedItems) {
      if (this._value.promotedItems === current.promotedItems) {
        result._selfPromotedItems = this._selfPromotedItems;
      } else {
        result._selfPromotedItems = [];
        for (let i = 0; i < current.promotedItems.length; i++) {
          const oldValue = this._value.promotedItems[i];
          if (oldValue) {
            const oldCache = this._selfPromotedItems[i];
            if (oldValue === current.promotedItems[i]) {
              result._selfPromotedItems[i] = oldCache;
            } else {
              result._selfPromotedItems[i] = oldCache.update(current.promotedItems[i], null);
            }
          } else {
            result._selfPromotedItems[i] = new Chest_PromotedItem.WithParent(current.promotedItems[i], null);
          }
        }
      }
    }
    if (this._selfDisplayMessages) {
      if (this._value.displayMessages === current.displayMessages) {
        result._selfDisplayMessages = this._selfDisplayMessages;
      } else {
        result._selfDisplayMessages = [];
        for (let i = 0; i < current.displayMessages.length; i++) {
          const oldValue = this._value.displayMessages[i];
          if (oldValue) {
            const oldCache = this._selfDisplayMessages[i];
            if (oldValue === current.displayMessages[i]) {
              result._selfDisplayMessages[i] = oldCache;
            } else {
              result._selfDisplayMessages[i] = oldCache.update(current.displayMessages[i], null);
            }
          } else {
            result._selfDisplayMessages[i] = new Chest_DisplayMessage.WithParent(current.displayMessages[i], null);
          }
        }
      }
    }
    return result;
  }
}
Chest_WithParent.default = new Chest_WithParent(Chest.default, null);
Chest.WithParent = Chest_WithParent;
class Chest_Descriptor {
  get slots() {
    if (!this._slots) {
      this._slots = {
        name: "slots",
        Name: "Slots",
        number: 1,
        protoType: 11,
        protoName: "slots",
        type: ChestSlot,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slots;
  }
  get currencyKey() {
    if (!this._currencyKey) {
      this._currencyKey = {
        name: "currencyKey",
        Name: "CurrencyKey",
        number: 2,
        protoType: 9,
        protoName: "currency_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currencyKey;
  }
  get currencyAmount() {
    if (!this._currencyAmount) {
      this._currencyAmount = {
        name: "currencyAmount",
        Name: "CurrencyAmount",
        number: 3,
        protoType: 5,
        protoName: "currency_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currencyAmount;
  }
  get alternativeCurrencyKey() {
    if (!this._alternativeCurrencyKey) {
      this._alternativeCurrencyKey = {
        name: "alternativeCurrencyKey",
        Name: "AlternativeCurrencyKey",
        number: 30,
        protoType: 9,
        protoName: "alternative_currency_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._alternativeCurrencyKey;
  }
  get alternativeCurrencyAmount() {
    if (!this._alternativeCurrencyAmount) {
      this._alternativeCurrencyAmount = {
        name: "alternativeCurrencyAmount",
        Name: "AlternativeCurrencyAmount",
        number: 31,
        protoType: 5,
        protoName: "alternative_currency_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._alternativeCurrencyAmount;
  }
  get tier() {
    if (!this._tier) {
      this._tier = {
        name: "tier",
        Name: "Tier",
        number: 4,
        protoType: 5,
        protoName: "tier",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tier;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 5,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get displayNameOverwriteInChestView() {
    if (!this._displayNameOverwriteInChestView) {
      this._displayNameOverwriteInChestView = {
        name: "displayNameOverwriteInChestView",
        Name: "DisplayNameOverwriteInChestView",
        number: 16,
        protoType: 9,
        protoName: "display_name_overwrite_in_chest_view",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayNameOverwriteInChestView;
  }
  get enableTenDraws() {
    if (!this._enableTenDraws) {
      this._enableTenDraws = {
        name: "enableTenDraws",
        Name: "EnableTenDraws",
        number: 6,
        protoType: 8,
        protoName: "enable_ten_draws",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enableTenDraws;
  }
  get currencyAmountTenDraws() {
    if (!this._currencyAmountTenDraws) {
      this._currencyAmountTenDraws = {
        name: "currencyAmountTenDraws",
        Name: "CurrencyAmountTenDraws",
        number: 7,
        protoType: 5,
        protoName: "currency_amount_ten_draws",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currencyAmountTenDraws;
  }
  get alternativeCurrencyAmountTenDraws() {
    if (!this._alternativeCurrencyAmountTenDraws) {
      this._alternativeCurrencyAmountTenDraws = {
        name: "alternativeCurrencyAmountTenDraws",
        Name: "AlternativeCurrencyAmountTenDraws",
        number: 32,
        protoType: 5,
        protoName: "alternative_currency_amount_ten_draws",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._alternativeCurrencyAmountTenDraws;
  }
  get enableTenDrawsGuaranteeReward() {
    if (!this._enableTenDrawsGuaranteeReward) {
      this._enableTenDrawsGuaranteeReward = {
        name: "enableTenDrawsGuaranteeReward",
        Name: "EnableTenDrawsGuaranteeReward",
        number: 8,
        protoType: 8,
        protoName: "enable_ten_draws_guarantee_reward",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enableTenDrawsGuaranteeReward;
  }
  get tenDrawGuaranteeRewards() {
    if (!this._tenDrawGuaranteeRewards) {
      this._tenDrawGuaranteeRewards = {
        name: "tenDrawGuaranteeRewards",
        Name: "TenDrawGuaranteeRewards",
        number: 14,
        protoType: 11,
        protoName: "ten_draw_guarantee_rewards",
        type: Chest_TenDrawGuaranteeReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tenDrawGuaranteeRewards;
  }
  get enablePromotedItems() {
    if (!this._enablePromotedItems) {
      this._enablePromotedItems = {
        name: "enablePromotedItems",
        Name: "EnablePromotedItems",
        number: 11,
        protoType: 8,
        protoName: "enable_promoted_items",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enablePromotedItems;
  }
  get xThDrawsPromotionBegin() {
    if (!this._xThDrawsPromotionBegin) {
      this._xThDrawsPromotionBegin = {
        name: "xThDrawsPromotionBegin",
        Name: "XThDrawsPromotionBegin",
        number: 12,
        protoType: 5,
        protoName: "x_th_draws_promotion_begin",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xThDrawsPromotionBegin;
  }
  get expectedDrawCountOfPromotedItems() {
    if (!this._expectedDrawCountOfPromotedItems) {
      this._expectedDrawCountOfPromotedItems = {
        name: "expectedDrawCountOfPromotedItems",
        Name: "ExpectedDrawCountOfPromotedItems",
        number: 15,
        protoType: 5,
        protoName: "expected_draw_count_of_promoted_items",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expectedDrawCountOfPromotedItems;
  }
  get promotedItems() {
    if (!this._promotedItems) {
      this._promotedItems = {
        name: "promotedItems",
        Name: "PromotedItems",
        number: 13,
        protoType: 11,
        protoName: "promoted_items",
        type: Chest_PromotedItem,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotedItems;
  }
  get chestRewardTypeInfo() {
    if (!this._chestRewardTypeInfo) {
      this._chestRewardTypeInfo = {
        name: "chestRewardTypeInfo",
        Name: "ChestRewardTypeInfo",
        number: 50,
        protoType: 9,
        protoName: "chest_reward_type_info",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestRewardTypeInfo;
  }
  get chestRewardTypeInfo2() {
    if (!this._chestRewardTypeInfo2) {
      this._chestRewardTypeInfo2 = {
        name: "chestRewardTypeInfo2",
        Name: "ChestRewardTypeInfo2",
        number: 53,
        protoType: 9,
        protoName: "chest_reward_type_info_2",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestRewardTypeInfo2;
  }
  get displayMessages() {
    if (!this._displayMessages) {
      this._displayMessages = {
        name: "displayMessages",
        Name: "DisplayMessages",
        number: 51,
        protoType: 11,
        protoName: "display_messages",
        type: Chest_DisplayMessage,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayMessages;
  }
  get displayPossibleRewardsDropPercentage() {
    if (!this._displayPossibleRewardsDropPercentage) {
      this._displayPossibleRewardsDropPercentage = {
        name: "displayPossibleRewardsDropPercentage",
        Name: "DisplayPossibleRewardsDropPercentage",
        number: 54,
        protoType: 1,
        protoName: "display_possible_rewards_drop_percentage",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayPossibleRewardsDropPercentage;
  }
  get dropRateInfo() {
    if (!this._dropRateInfo) {
      this._dropRateInfo = {
        name: "dropRateInfo",
        Name: "DropRateInfo",
        number: 52,
        protoType: 9,
        protoName: "drop_rate_info",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dropRateInfo;
  }
  get chestCloseImage() {
    if (!this._chestCloseImage) {
      this._chestCloseImage = {
        name: "chestCloseImage",
        Name: "ChestCloseImage",
        number: 71,
        protoType: 9,
        protoName: "chest_close_image",
        type: JsonToString,
        options: {
          valueDropdown: "ChestIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestCloseImage;
  }
  get chestOpenImage() {
    if (!this._chestOpenImage) {
      this._chestOpenImage = {
        name: "chestOpenImage",
        Name: "ChestOpenImage",
        number: 72,
        protoType: 9,
        protoName: "chest_open_image",
        type: JsonToString,
        options: {
          valueDropdown: "ChestIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestOpenImage;
  }
  get chestPrefab() {
    if (!this._chestPrefab) {
      this._chestPrefab = {
        name: "chestPrefab",
        Name: "ChestPrefab",
        number: 73,
        protoType: 9,
        protoName: "chest_prefab",
        type: JsonToString,
        options: {
          valueDropdown: "ChestPrefabs",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestPrefab;
  }
  get showcasePrefab() {
    if (!this._showcasePrefab) {
      this._showcasePrefab = {
        name: "showcasePrefab",
        Name: "ShowcasePrefab",
        number: 74,
        protoType: 9,
        protoName: "showcase_prefab",
        type: JsonToString,
        options: {
          valueDropdown: "ChestShowcasePrefabs",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showcasePrefab;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.slots,
        this.currencyKey,
        this.currencyAmount,
        this.alternativeCurrencyKey,
        this.alternativeCurrencyAmount,
        this.tier,
        this.displayName,
        this.displayNameOverwriteInChestView,
        this.enableTenDraws,
        this.currencyAmountTenDraws,
        this.alternativeCurrencyAmountTenDraws,
        this.enableTenDrawsGuaranteeReward,
        this.tenDrawGuaranteeRewards,
        this.enablePromotedItems,
        this.xThDrawsPromotionBegin,
        this.expectedDrawCountOfPromotedItems,
        this.promotedItems,
        this.chestRewardTypeInfo,
        this.chestRewardTypeInfo2,
        this.displayMessages,
        this.displayPossibleRewardsDropPercentage,
        this.dropRateInfo,
        this.chestCloseImage,
        this.chestOpenImage,
        this.chestPrefab,
        this.showcasePrefab,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrencyKey",
        Name: "DummyOneofForCurrencyKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrencyAmount",
        Name: "DummyOneofForCurrencyAmount",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAlternativeCurrencyKey",
        Name: "DummyOneofForAlternativeCurrencyKey",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAlternativeCurrencyAmount",
        Name: "DummyOneofForAlternativeCurrencyAmount",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTier",
        Name: "DummyOneofForTier",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayNameOverwriteInChestView",
        Name: "DummyOneofForDisplayNameOverwriteInChestView",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnableTenDraws",
        Name: "DummyOneofForEnableTenDraws",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrencyAmountTenDraws",
        Name: "DummyOneofForCurrencyAmountTenDraws",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAlternativeCurrencyAmountTenDraws",
        Name: "DummyOneofForAlternativeCurrencyAmountTenDraws",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnableTenDrawsGuaranteeReward",
        Name: "DummyOneofForEnableTenDrawsGuaranteeReward",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnablePromotedItems",
        Name: "DummyOneofForEnablePromotedItems",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForXThDrawsPromotionBegin",
        Name: "DummyOneofForXThDrawsPromotionBegin",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExpectedDrawCountOfPromotedItems",
        Name: "DummyOneofForExpectedDrawCountOfPromotedItems",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestRewardTypeInfo",
        Name: "DummyOneofForChestRewardTypeInfo",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestRewardTypeInfo2",
        Name: "DummyOneofForChestRewardTypeInfo2",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayPossibleRewardsDropPercentage",
        Name: "DummyOneofForDisplayPossibleRewardsDropPercentage",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDropRateInfo",
        Name: "DummyOneofForDropRateInfo",
        fields: [
          this.fields[21],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestCloseImage",
        Name: "DummyOneofForChestCloseImage",
        fields: [
          this.fields[22],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestOpenImage",
        Name: "DummyOneofForChestOpenImage",
        fields: [
          this.fields[23],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestPrefab",
        Name: "DummyOneofForChestPrefab",
        fields: [
          this.fields[24],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowcasePrefab",
        Name: "DummyOneofForShowcasePrefab",
        fields: [
          this.fields[25],
        ],
      });
    }
    return this._oneofs;
  }
}
Chest.descriptor = new Chest_Descriptor();
